export const zfbArea = [{
    "text": "北京",
    "value": 110000,
    "children": [{
        "text": "北京市",
        "value": 110100,
        "children": [{
            "text": "东城区",
            "value": 110101
        }, {
            "text": "西城区",
            "value": 110102
        }, {
            "text": "朝阳区",
            "value": 110105
        }, {
            "text": "丰台区",
            "value": 110106
        }, {
            "text": "石景山区",
            "value": 110107
        }, {
            "text": "海淀区",
            "value": 110108
        }, {
            "text": "门头沟区",
            "value": 110109
        }, {
            "text": "房山区",
            "value": 110111
        }, {
            "text": "通州区",
            "value": 110112
        }, {
            "text": "顺义区",
            "value": 110113
        }, {
            "text": "昌平区",
            "value": 110114
        }, {
            "text": "大兴区",
            "value": 110115
        }, {
            "text": "怀柔区",
            "value": 110116
        }, {
            "text": "平谷区",
            "value": 110117
        }, {
            "text": "密云区",
            "value": 110118
        }, {
            "text": "延庆区",
            "value": 110119
        }]
    }]
}, {
    "text": "天津",
    "value": 120000,
    "children": [{
        "text": "天津市",
        "value": 120100,
        "children": [{
            "text": "和平区",
            "value": 120101
        }, {
            "text": "河东区",
            "value": 120102
        }, {
            "text": "河西区",
            "value": 120103
        }, {
            "text": "南开区",
            "value": 120104
        }, {
            "text": "河北区",
            "value": 120105
        }, {
            "text": "红桥区",
            "value": 120106
        }, {
            "text": "东丽区",
            "value": 120110
        }, {
            "text": "西青区",
            "value": 120111
        }, {
            "text": "津南区",
            "value": 120112
        }, {
            "text": "北辰区",
            "value": 120113
        }, {
            "text": "武清区",
            "value": 120114
        }, {
            "text": "宝坻区",
            "value": 120115
        }, {
            "text": "滨海新区",
            "value": 120116
        }, {
            "text": "宁河区",
            "value": 120117
        }, {
            "text": "静海区",
            "value": 120118
        }, {
            "text": "蓟州区",
            "value": 120119
        }]
    }]
}, {
    "text": "河北省",
    "value": 130000,
    "children": [{
        "text": "石家庄市",
        "value": 130100,
        "children": [{
            "text": "长安区",
            "value": 130102
        }, {
            "text": "桥西区",
            "value": 130104
        }, {
            "text": "新华区",
            "value": 130105
        }, {
            "text": "井陉矿区",
            "value": 130107
        }, {
            "text": "裕华区",
            "value": 130108
        }, {
            "text": "藁城区",
            "value": 130109
        }, {
            "text": "鹿泉区",
            "value": 130110
        }, {
            "text": "栾城区",
            "value": 130111
        }, {
            "text": "井陉县",
            "value": 130121
        }, {
            "text": "正定县",
            "value": 130123
        }, {
            "text": "行唐县",
            "value": 130125
        }, {
            "text": "灵寿县",
            "value": 130126
        }, {
            "text": "高邑县",
            "value": 130127
        }, {
            "text": "深泽县",
            "value": 130128
        }, {
            "text": "赞皇县",
            "value": 130129
        }, {
            "text": "无极县",
            "value": 130130
        }, {
            "text": "平山县",
            "value": 130131
        }, {
            "text": "元氏县",
            "value": 130132
        }, {
            "text": "赵县",
            "value": 130133
        }, {
            "text": "辛集市",
            "value": 130181
        }, {
            "text": "晋州市",
            "value": 130183
        }, {
            "text": "新乐市",
            "value": 130184
        }]
    }, {
        "text": "唐山市",
        "value": 130200,
        "children": [{
            "text": "路南区",
            "value": 130202
        }, {
            "text": "路北区",
            "value": 130203
        }, {
            "text": "古冶区",
            "value": 130204
        }, {
            "text": "开平区",
            "value": 130205
        }, {
            "text": "丰南区",
            "value": 130207
        }, {
            "text": "丰润区",
            "value": 130208
        }, {
            "text": "曹妃甸区",
            "value": 130209
        }, {
            "text": "滦南县",
            "value": 130224
        }, {
            "text": "乐亭县",
            "value": 130225
        }, {
            "text": "迁西县",
            "value": 130227
        }, {
            "text": "玉田县",
            "value": 130229
        }, {
            "text": "遵化市",
            "value": 130281
        }, {
            "text": "迁安市",
            "value": 130283
        }, {
            "text": "滦州市",
            "value": 130284
        }]
    }, {
        "text": "秦皇岛市",
        "value": 130300,
        "children": [{
            "text": "海港区",
            "value": 130302
        }, {
            "text": "山海关区",
            "value": 130303
        }, {
            "text": "北戴河区",
            "value": 130304
        }, {
            "text": "抚宁区",
            "value": 130306
        }, {
            "text": "青龙满族自治县",
            "value": 130321
        }, {
            "text": "昌黎县",
            "value": 130322
        }, {
            "text": "卢龙县",
            "value": 130324
        }]
    }, {
        "text": "邯郸市",
        "value": 130400,
        "children": [{
            "text": "邯山区",
            "value": 130402
        }, {
            "text": "丛台区",
            "value": 130403
        }, {
            "text": "复兴区",
            "value": 130404
        }, {
            "text": "峰峰矿区",
            "value": 130406
        }, {
            "text": "肥乡区",
            "value": 130407
        }, {
            "text": "永年区",
            "value": 130408
        }, {
            "text": "临漳县",
            "value": 130423
        }, {
            "text": "成安县",
            "value": 130424
        }, {
            "text": "大名县",
            "value": 130425
        }, {
            "text": "涉县",
            "value": 130426
        }, {
            "text": "磁县",
            "value": 130427
        }, {
            "text": "邱县",
            "value": 130430
        }, {
            "text": "鸡泽县",
            "value": 130431
        }, {
            "text": "广平县",
            "value": 130432
        }, {
            "text": "馆陶县",
            "value": 130433
        }, {
            "text": "魏县",
            "value": 130434
        }, {
            "text": "曲周县",
            "value": 130435
        }, {
            "text": "武安市",
            "value": 130481
        }]
    }, {
        "text": "邢台市",
        "value": 130500,
        "children": [{
            "text": "桥东区",
            "value": 130502
        }, {
            "text": "桥西区",
            "value": 130503
        }, {
            "text": "邢台县",
            "value": 130521
        }, {
            "text": "临城县",
            "value": 130522
        }, {
            "text": "内丘县",
            "value": 130523
        }, {
            "text": "柏乡县",
            "value": 130524
        }, {
            "text": "隆尧县",
            "value": 130525
        }, {
            "text": "任县",
            "value": 130526
        }, {
            "text": "南和县",
            "value": 130527
        }, {
            "text": "宁晋县",
            "value": 130528
        }, {
            "text": "巨鹿县",
            "value": 130529
        }, {
            "text": "新河县",
            "value": 130530
        }, {
            "text": "广宗县",
            "value": 130531
        }, {
            "text": "平乡县",
            "value": 130532
        }, {
            "text": "威县",
            "value": 130533
        }, {
            "text": "清河县",
            "value": 130534
        }, {
            "text": "临西县",
            "value": 130535
        }, {
            "text": "南宫市",
            "value": 130581
        }, {
            "text": "沙河市",
            "value": 130582
        }]
    }, {
        "text": "保定市",
        "value": 130600,
        "children": [{
            "text": "竞秀区",
            "value": 130602
        }, {
            "text": "莲池区",
            "value": 130606
        }, {
            "text": "满城区",
            "value": 130607
        }, {
            "text": "清苑区",
            "value": 130608
        }, {
            "text": "徐水区",
            "value": 130609
        }, {
            "text": "涞水县",
            "value": 130623
        }, {
            "text": "阜平县",
            "value": 130624
        }, {
            "text": "定兴县",
            "value": 130626
        }, {
            "text": "唐县",
            "value": 130627
        }, {
            "text": "高阳县",
            "value": 130628
        }, {
            "text": "容城县",
            "value": 130629
        }, {
            "text": "涞源县",
            "value": 130630
        }, {
            "text": "望都县",
            "value": 130631
        }, {
            "text": "安新县",
            "value": 130632
        }, {
            "text": "易县",
            "value": 130633
        }, {
            "text": "曲阳县",
            "value": 130634
        }, {
            "text": "蠡县",
            "value": 130635
        }, {
            "text": "顺平县",
            "value": 130636
        }, {
            "text": "博野县",
            "value": 130637
        }, {
            "text": "雄县",
            "value": 130638
        }, {
            "text": "涿州市",
            "value": 130681
        }, {
            "text": "定州市",
            "value": 130682
        }, {
            "text": "安国市",
            "value": 130683
        }, {
            "text": "高碑店市",
            "value": 130684
        }]
    }, {
        "text": "张家口市",
        "value": 130700,
        "children": [{
            "text": "桥东区",
            "value": 130702
        }, {
            "text": "桥西区",
            "value": 130703
        }, {
            "text": "宣化区",
            "value": 130705
        }, {
            "text": "下花园区",
            "value": 130706
        }, {
            "text": "万全区",
            "value": 130708
        }, {
            "text": "崇礼区",
            "value": 130709
        }, {
            "text": "张北县",
            "value": 130722
        }, {
            "text": "康保县",
            "value": 130723
        }, {
            "text": "沽源县",
            "value": 130724
        }, {
            "text": "尚义县",
            "value": 130725
        }, {
            "text": "蔚县",
            "value": 130726
        }, {
            "text": "阳原县",
            "value": 130727
        }, {
            "text": "怀安县",
            "value": 130728
        }, {
            "text": "怀来县",
            "value": 130730
        }, {
            "text": "涿鹿县",
            "value": 130731
        }, {
            "text": "赤城县",
            "value": 130732
        }]
    }, {
        "text": "承德市",
        "value": 130800,
        "children": [{
            "text": "双桥区",
            "value": 130802
        }, {
            "text": "双滦区",
            "value": 130803
        }, {
            "text": "鹰手营子矿区",
            "value": 130804
        }, {
            "text": "承德县",
            "value": 130821
        }, {
            "text": "兴隆县",
            "value": 130822
        }, {
            "text": "滦平县",
            "value": 130824
        }, {
            "text": "隆化县",
            "value": 130825
        }, {
            "text": "丰宁满族自治县",
            "value": 130826
        }, {
            "text": "宽城满族自治县",
            "value": 130827
        }, {
            "text": "围场满族蒙古族自治县",
            "value": 130828
        }, {
            "text": "平泉市",
            "value": 130881
        }]
    }, {
        "text": "沧州市",
        "value": 130900,
        "children": [{
            "text": "新华区",
            "value": 130902
        }, {
            "text": "运河区",
            "value": 130903
        }, {
            "text": "沧县",
            "value": 130921
        }, {
            "text": "青县",
            "value": 130922
        }, {
            "text": "东光县",
            "value": 130923
        }, {
            "text": "海兴县",
            "value": 130924
        }, {
            "text": "盐山县",
            "value": 130925
        }, {
            "text": "肃宁县",
            "value": 130926
        }, {
            "text": "南皮县",
            "value": 130927
        }, {
            "text": "吴桥县",
            "value": 130928
        }, {
            "text": "献县",
            "value": 130929
        }, {
            "text": "孟村回族自治县",
            "value": 130930
        }, {
            "text": "泊头市",
            "value": 130981
        }, {
            "text": "任丘市",
            "value": 130982
        }, {
            "text": "黄骅市",
            "value": 130983
        }, {
            "text": "河间市",
            "value": 130984
        }]
    }, {
        "text": "廊坊市",
        "value": 131000,
        "children": [{
            "text": "安次区",
            "value": 131002
        }, {
            "text": "广阳区",
            "value": 131003
        }, {
            "text": "固安县",
            "value": 131022
        }, {
            "text": "永清县",
            "value": 131023
        }, {
            "text": "香河县",
            "value": 131024
        }, {
            "text": "大城县",
            "value": 131025
        }, {
            "text": "文安县",
            "value": 131026
        }, {
            "text": "大厂回族自治县",
            "value": 131028
        }, {
            "text": "霸州市",
            "value": 131081
        }, {
            "text": "三河市",
            "value": 131082
        }]
    }, {
        "text": "衡水市",
        "value": 131100,
        "children": [{
            "text": "桃城区",
            "value": 131102
        }, {
            "text": "冀州区",
            "value": 131103
        }, {
            "text": "枣强县",
            "value": 131121
        }, {
            "text": "武邑县",
            "value": 131122
        }, {
            "text": "武强县",
            "value": 131123
        }, {
            "text": "饶阳县",
            "value": 131124
        }, {
            "text": "安平县",
            "value": 131125
        }, {
            "text": "故城县",
            "value": 131126
        }, {
            "text": "景县",
            "value": 131127
        }, {
            "text": "阜城县",
            "value": 131128
        }, {
            "text": "深州市",
            "value": 131182
        }]
    }]
}, {
    "text": "山西省",
    "value": 140000,
    "children": [{
        "text": "太原市",
        "value": 140100,
        "children": [{
            "text": "小店区",
            "value": 140105
        }, {
            "text": "迎泽区",
            "value": 140106
        }, {
            "text": "杏花岭区",
            "value": 140107
        }, {
            "text": "尖草坪区",
            "value": 140108
        }, {
            "text": "万柏林区",
            "value": 140109
        }, {
            "text": "晋源区",
            "value": 140110
        }, {
            "text": "清徐县",
            "value": 140121
        }, {
            "text": "阳曲县",
            "value": 140122
        }, {
            "text": "娄烦县",
            "value": 140123
        }, {
            "text": "古交市",
            "value": 140181
        }]
    }, {
        "text": "大同市",
        "value": 140200,
        "children": [{
            "text": "新荣区",
            "value": 140212
        }, {
            "text": "平城区",
            "value": 140213
        }, {
            "text": "云冈区",
            "value": 140214
        }, {
            "text": "云州区",
            "value": 140215
        }, {
            "text": "阳高县",
            "value": 140221
        }, {
            "text": "天镇县",
            "value": 140222
        }, {
            "text": "广灵县",
            "value": 140223
        }, {
            "text": "灵丘县",
            "value": 140224
        }, {
            "text": "浑源县",
            "value": 140225
        }, {
            "text": "左云县",
            "value": 140226
        }]
    }, {
        "text": "阳泉市",
        "value": 140300,
        "children": [{
            "text": "城区",
            "value": 140302
        }, {
            "text": "矿区",
            "value": 140303
        }, {
            "text": "郊区",
            "value": 140311
        }, {
            "text": "平定县",
            "value": 140321
        }, {
            "text": "盂县",
            "value": 140322
        }]
    }, {
        "text": "长治市",
        "value": 140400,
        "children": [{
            "text": "潞州区",
            "value": 140403
        }, {
            "text": "上党区",
            "value": 140404
        }, {
            "text": "屯留区",
            "value": 140405
        }, {
            "text": "潞城区",
            "value": 140406
        }, {
            "text": "襄垣县",
            "value": 140423
        }, {
            "text": "平顺县",
            "value": 140425
        }, {
            "text": "黎城县",
            "value": 140426
        }, {
            "text": "壶关县",
            "value": 140427
        }, {
            "text": "长子县",
            "value": 140428
        }, {
            "text": "武乡县",
            "value": 140429
        }, {
            "text": "沁县",
            "value": 140430
        }, {
            "text": "沁源县",
            "value": 140431
        }]
    }, {
        "text": "晋城市",
        "value": 140500,
        "children": [{
            "text": "城区",
            "value": 140502
        }, {
            "text": "沁水县",
            "value": 140521
        }, {
            "text": "阳城县",
            "value": 140522
        }, {
            "text": "陵川县",
            "value": 140524
        }, {
            "text": "泽州县",
            "value": 140525
        }, {
            "text": "高平市",
            "value": 140581
        }]
    }, {
        "text": "朔州市",
        "value": 140600,
        "children": [{
            "text": "朔城区",
            "value": 140602
        }, {
            "text": "平鲁区",
            "value": 140603
        }, {
            "text": "山阴县",
            "value": 140621
        }, {
            "text": "应县",
            "value": 140622
        }, {
            "text": "右玉县",
            "value": 140623
        }, {
            "text": "怀仁市",
            "value": 140681
        }]
    }, {
        "text": "晋中市",
        "value": 140700,
        "children": [{
            "text": "榆次区",
            "value": 140702
        }, {
            "text": "太谷区",
            "value": 140703
        }, {
            "text": "榆社县",
            "value": 140721
        }, {
            "text": "左权县",
            "value": 140722
        }, {
            "text": "和顺县",
            "value": 140723
        }, {
            "text": "昔阳县",
            "value": 140724
        }, {
            "text": "寿阳县",
            "value": 140725
        }, {
            "text": "祁县",
            "value": 140727
        }, {
            "text": "平遥县",
            "value": 140728
        }, {
            "text": "灵石县",
            "value": 140729
        }, {
            "text": "介休市",
            "value": 140781
        }]
    }, {
        "text": "运城市",
        "value": 140800,
        "children": [{
            "text": "盐湖区",
            "value": 140802
        }, {
            "text": "临猗县",
            "value": 140821
        }, {
            "text": "万荣县",
            "value": 140822
        }, {
            "text": "闻喜县",
            "value": 140823
        }, {
            "text": "稷山县",
            "value": 140824
        }, {
            "text": "新绛县",
            "value": 140825
        }, {
            "text": "绛县",
            "value": 140826
        }, {
            "text": "垣曲县",
            "value": 140827
        }, {
            "text": "夏县",
            "value": 140828
        }, {
            "text": "平陆县",
            "value": 140829
        }, {
            "text": "芮城县",
            "value": 140830
        }, {
            "text": "永济市",
            "value": 140881
        }, {
            "text": "河津市",
            "value": 140882
        }]
    }, {
        "text": "忻州市",
        "value": 140900,
        "children": [{
            "text": "忻府区",
            "value": 140902
        }, {
            "text": "定襄县",
            "value": 140921
        }, {
            "text": "五台县",
            "value": 140922
        }, {
            "text": "代县",
            "value": 140923
        }, {
            "text": "繁峙县",
            "value": 140924
        }, {
            "text": "宁武县",
            "value": 140925
        }, {
            "text": "静乐县",
            "value": 140926
        }, {
            "text": "神池县",
            "value": 140927
        }, {
            "text": "五寨县",
            "value": 140928
        }, {
            "text": "岢岚县",
            "value": 140929
        }, {
            "text": "河曲县",
            "value": 140930
        }, {
            "text": "保德县",
            "value": 140931
        }, {
            "text": "偏关县",
            "value": 140932
        }, {
            "text": "原平市",
            "value": 140981
        }]
    }, {
        "text": "临汾市",
        "value": 141000,
        "children": [{
            "text": "尧都区",
            "value": 141002
        }, {
            "text": "曲沃县",
            "value": 141021
        }, {
            "text": "翼城县",
            "value": 141022
        }, {
            "text": "襄汾县",
            "value": 141023
        }, {
            "text": "洪洞县",
            "value": 141024
        }, {
            "text": "古县",
            "value": 141025
        }, {
            "text": "安泽县",
            "value": 141026
        }, {
            "text": "浮山县",
            "value": 141027
        }, {
            "text": "吉县",
            "value": 141028
        }, {
            "text": "乡宁县",
            "value": 141029
        }, {
            "text": "大宁县",
            "value": 141030
        }, {
            "text": "隰县",
            "value": 141031
        }, {
            "text": "永和县",
            "value": 141032
        }, {
            "text": "蒲县",
            "value": 141033
        }, {
            "text": "汾西县",
            "value": 141034
        }, {
            "text": "侯马市",
            "value": 141081
        }, {
            "text": "霍州市",
            "value": 141082
        }]
    }, {
        "text": "吕梁市",
        "value": 141100,
        "children": [{
            "text": "离石区",
            "value": 141102
        }, {
            "text": "文水县",
            "value": 141121
        }, {
            "text": "交城县",
            "value": 141122
        }, {
            "text": "兴县",
            "value": 141123
        }, {
            "text": "临县",
            "value": 141124
        }, {
            "text": "柳林县",
            "value": 141125
        }, {
            "text": "石楼县",
            "value": 141126
        }, {
            "text": "岚县",
            "value": 141127
        }, {
            "text": "方山县",
            "value": 141128
        }, {
            "text": "中阳县",
            "value": 141129
        }, {
            "text": "交口县",
            "value": 141130
        }, {
            "text": "孝义市",
            "value": 141181
        }, {
            "text": "汾阳市",
            "value": 141182
        }]
    }]
}, {
    "text": "内蒙古自治区",
    "value": 150000,
    "children": [{
        "text": "呼和浩特市",
        "value": 150100,
        "children": [{
            "text": "新城区",
            "value": 150102
        }, {
            "text": "回民区",
            "value": 150103
        }, {
            "text": "玉泉区",
            "value": 150104
        }, {
            "text": "赛罕区",
            "value": 150105
        }, {
            "text": "土默特左旗",
            "value": 150121
        }, {
            "text": "托克托县",
            "value": 150122
        }, {
            "text": "和林格尔县",
            "value": 150123
        }, {
            "text": "清水河县",
            "value": 150124
        }, {
            "text": "武川县",
            "value": 150125
        }]
    }, {
        "text": "包头市",
        "value": 150200,
        "children": [{
            "text": "东河区",
            "value": 150202
        }, {
            "text": "昆都仑区",
            "value": 150203
        }, {
            "text": "青山区",
            "value": 150204
        }, {
            "text": "石拐区",
            "value": 150205
        }, {
            "text": "白云鄂博矿区",
            "value": 150206
        }, {
            "text": "九原区",
            "value": 150207
        }, {
            "text": "土默特右旗",
            "value": 150221
        }, {
            "text": "固阳县",
            "value": 150222
        }, {
            "text": "达尔罕茂明安联合旗",
            "value": 150223
        }]
    }, {
        "text": "乌海市",
        "value": 150300,
        "children": [{
            "text": "海勃湾区",
            "value": 150302
        }, {
            "text": "海南区",
            "value": 150303
        }, {
            "text": "乌达区",
            "value": 150304
        }]
    }, {
        "text": "赤峰市",
        "value": 150400,
        "children": [{
            "text": "红山区",
            "value": 150402
        }, {
            "text": "元宝山区",
            "value": 150403
        }, {
            "text": "松山区",
            "value": 150404
        }, {
            "text": "阿鲁科尔沁旗",
            "value": 150421
        }, {
            "text": "巴林左旗",
            "value": 150422
        }, {
            "text": "巴林右旗",
            "value": 150423
        }, {
            "text": "林西县",
            "value": 150424
        }, {
            "text": "克什克腾旗",
            "value": 150425
        }, {
            "text": "翁牛特旗",
            "value": 150426
        }, {
            "text": "喀喇沁旗",
            "value": 150428
        }, {
            "text": "宁城县",
            "value": 150429
        }, {
            "text": "敖汉旗",
            "value": 150430
        }]
    }, {
        "text": "通辽市",
        "value": 150500,
        "children": [{
            "text": "科尔沁区",
            "value": 150502
        }, {
            "text": "科尔沁左翼中旗",
            "value": 150521
        }, {
            "text": "科尔沁左翼后旗",
            "value": 150522
        }, {
            "text": "开鲁县",
            "value": 150523
        }, {
            "text": "库伦旗",
            "value": 150524
        }, {
            "text": "奈曼旗",
            "value": 150525
        }, {
            "text": "扎鲁特旗",
            "value": 150526
        }, {
            "text": "霍林郭勒市",
            "value": 150581
        }]
    }, {
        "text": "鄂尔多斯市",
        "value": 150600,
        "children": [{
            "text": "东胜区",
            "value": 150602
        }, {
            "text": "康巴什区",
            "value": 150603
        }, {
            "text": "达拉特旗",
            "value": 150621
        }, {
            "text": "准格尔旗",
            "value": 150622
        }, {
            "text": "鄂托克前旗",
            "value": 150623
        }, {
            "text": "鄂托克旗",
            "value": 150624
        }, {
            "text": "杭锦旗",
            "value": 150625
        }, {
            "text": "乌审旗",
            "value": 150626
        }, {
            "text": "伊金霍洛旗",
            "value": 150627
        }]
    }, {
        "text": "呼伦贝尔市",
        "value": 150700,
        "children": [{
            "text": "海拉尔区",
            "value": 150702
        }, {
            "text": "扎赉诺尔区",
            "value": 150703
        }, {
            "text": "阿荣旗",
            "value": 150721
        }, {
            "text": "莫力达瓦达斡尔族自治旗",
            "value": 150722
        }, {
            "text": "鄂伦春自治旗",
            "value": 150723
        }, {
            "text": "鄂温克族自治旗",
            "value": 150724
        }, {
            "text": "陈巴尔虎旗",
            "value": 150725
        }, {
            "text": "新巴尔虎左旗",
            "value": 150726
        }, {
            "text": "新巴尔虎右旗",
            "value": 150727
        }, {
            "text": "满洲里市",
            "value": 150781
        }, {
            "text": "牙克石市",
            "value": 150782
        }, {
            "text": "扎兰屯市",
            "value": 150783
        }, {
            "text": "额尔古纳市",
            "value": 150784
        }, {
            "text": "根河市",
            "value": 150785
        }]
    }, {
        "text": "巴彦淖尔市",
        "value": 150800,
        "children": [{
            "text": "临河区",
            "value": 150802
        }, {
            "text": "五原县",
            "value": 150821
        }, {
            "text": "磴口县",
            "value": 150822
        }, {
            "text": "乌拉特前旗",
            "value": 150823
        }, {
            "text": "乌拉特中旗",
            "value": 150824
        }, {
            "text": "乌拉特后旗",
            "value": 150825
        }, {
            "text": "杭锦后旗",
            "value": 150826
        }]
    }, {
        "text": "乌兰察布市",
        "value": 150900,
        "children": [{
            "text": "集宁区",
            "value": 150902
        }, {
            "text": "卓资县",
            "value": 150921
        }, {
            "text": "化德县",
            "value": 150922
        }, {
            "text": "商都县",
            "value": 150923
        }, {
            "text": "兴和县",
            "value": 150924
        }, {
            "text": "凉城县",
            "value": 150925
        }, {
            "text": "察哈尔右翼前旗",
            "value": 150926
        }, {
            "text": "察哈尔右翼中旗",
            "value": 150927
        }, {
            "text": "察哈尔右翼后旗",
            "value": 150928
        }, {
            "text": "四子王旗",
            "value": 150929
        }, {
            "text": "丰镇市",
            "value": 150981
        }]
    }, {
        "text": "兴安盟",
        "value": 152200,
        "children": [{
            "text": "乌兰浩特市",
            "value": 152201
        }, {
            "text": "阿尔山市",
            "value": 152202
        }, {
            "text": "科尔沁右翼前旗",
            "value": 152221
        }, {
            "text": "科尔沁右翼中旗",
            "value": 152222
        }, {
            "text": "扎赉特旗",
            "value": 152223
        }, {
            "text": "突泉县",
            "value": 152224
        }]
    }, {
        "text": "锡林郭勒盟",
        "value": 152500,
        "children": [{
            "text": "二连浩特市",
            "value": 152501
        }, {
            "text": "锡林浩特市",
            "value": 152502
        }, {
            "text": "阿巴嘎旗",
            "value": 152522
        }, {
            "text": "苏尼特左旗",
            "value": 152523
        }, {
            "text": "苏尼特右旗",
            "value": 152524
        }, {
            "text": "东乌珠穆沁旗",
            "value": 152525
        }, {
            "text": "西乌珠穆沁旗",
            "value": 152526
        }, {
            "text": "太仆寺旗",
            "value": 152527
        }, {
            "text": "镶黄旗",
            "value": 152528
        }, {
            "text": "正镶白旗",
            "value": 152529
        }, {
            "text": "正蓝旗",
            "value": 152530
        }, {
            "text": "多伦县",
            "value": 152531
        }]
    }, {
        "text": "阿拉善盟",
        "value": 152900,
        "children": [{
            "text": "阿拉善左旗",
            "value": 152921
        }, {
            "text": "阿拉善右旗",
            "value": 152922
        }, {
            "text": "额济纳旗",
            "value": 152923
        }]
    }]
}, {
    "text": "辽宁省",
    "value": 210000,
    "children": [{
        "text": "沈阳市",
        "value": 210100,
        "children": [{
            "text": "和平区",
            "value": 210102
        }, {
            "text": "沈河区",
            "value": 210103
        }, {
            "text": "大东区",
            "value": 210104
        }, {
            "text": "皇姑区",
            "value": 210105
        }, {
            "text": "铁西区",
            "value": 210106
        }, {
            "text": "苏家屯区",
            "value": 210111
        }, {
            "text": "浑南区",
            "value": 210112
        }, {
            "text": "沈北新区",
            "value": 210113
        }, {
            "text": "于洪区",
            "value": 210114
        }, {
            "text": "辽中区",
            "value": 210115
        }, {
            "text": "康平县",
            "value": 210123
        }, {
            "text": "法库县",
            "value": 210124
        }, {
            "text": "新民市",
            "value": 210181
        }]
    }, {
        "text": "大连市",
        "value": 210200,
        "children": [{
            "text": "中山区",
            "value": 210202
        }, {
            "text": "西岗区",
            "value": 210203
        }, {
            "text": "沙河口区",
            "value": 210204
        }, {
            "text": "甘井子区",
            "value": 210211
        }, {
            "text": "旅顺口区",
            "value": 210212
        }, {
            "text": "金州区",
            "value": 210213
        }, {
            "text": "普兰店区",
            "value": 210214
        }, {
            "text": "长海县",
            "value": 210224
        }, {
            "text": "瓦房店市",
            "value": 210281
        }, {
            "text": "庄河市",
            "value": 210283
        }]
    }, {
        "text": "鞍山市",
        "value": 210300,
        "children": [{
            "text": "铁东区",
            "value": 210302
        }, {
            "text": "铁西区",
            "value": 210303
        }, {
            "text": "立山区",
            "value": 210304
        }, {
            "text": "千山区",
            "value": 210311
        }, {
            "text": "台安县",
            "value": 210321
        }, {
            "text": "岫岩满族自治县",
            "value": 210323
        }, {
            "text": "海城市",
            "value": 210381
        }]
    }, {
        "text": "抚顺市",
        "value": 210400,
        "children": [{
            "text": "新抚区",
            "value": 210402
        }, {
            "text": "东洲区",
            "value": 210403
        }, {
            "text": "望花区",
            "value": 210404
        }, {
            "text": "顺城区",
            "value": 210411
        }, {
            "text": "抚顺县",
            "value": 210421
        }, {
            "text": "新宾满族自治县",
            "value": 210422
        }, {
            "text": "清原满族自治县",
            "value": 210423
        }]
    }, {
        "text": "本溪市",
        "value": 210500,
        "children": [{
            "text": "平山区",
            "value": 210502
        }, {
            "text": "溪湖区",
            "value": 210503
        }, {
            "text": "明山区",
            "value": 210504
        }, {
            "text": "南芬区",
            "value": 210505
        }, {
            "text": "本溪满族自治县",
            "value": 210521
        }, {
            "text": "桓仁满族自治县",
            "value": 210522
        }]
    }, {
        "text": "丹东市",
        "value": 210600,
        "children": [{
            "text": "元宝区",
            "value": 210602
        }, {
            "text": "振兴区",
            "value": 210603
        }, {
            "text": "振安区",
            "value": 210604
        }, {
            "text": "宽甸满族自治县",
            "value": 210624
        }, {
            "text": "东港市",
            "value": 210681
        }, {
            "text": "凤城市",
            "value": 210682
        }]
    }, {
        "text": "锦州市",
        "value": 210700,
        "children": [{
            "text": "古塔区",
            "value": 210702
        }, {
            "text": "凌河区",
            "value": 210703
        }, {
            "text": "太和区",
            "value": 210711
        }, {
            "text": "黑山县",
            "value": 210726
        }, {
            "text": "义县",
            "value": 210727
        }, {
            "text": "凌海市",
            "value": 210781
        }, {
            "text": "北镇市",
            "value": 210782
        }]
    }, {
        "text": "营口市",
        "value": 210800,
        "children": [{
            "text": "站前区",
            "value": 210802
        }, {
            "text": "西市区",
            "value": 210803
        }, {
            "text": "鲅鱼圈区",
            "value": 210804
        }, {
            "text": "老边区",
            "value": 210811
        }, {
            "text": "盖州市",
            "value": 210881
        }, {
            "text": "大石桥市",
            "value": 210882
        }]
    }, {
        "text": "阜新市",
        "value": 210900,
        "children": [{
            "text": "海州区",
            "value": 210902
        }, {
            "text": "新邱区",
            "value": 210903
        }, {
            "text": "太平区",
            "value": 210904
        }, {
            "text": "清河门区",
            "value": 210905
        }, {
            "text": "细河区",
            "value": 210911
        }, {
            "text": "阜新蒙古族自治县",
            "value": 210921
        }, {
            "text": "彰武县",
            "value": 210922
        }]
    }, {
        "text": "辽阳市",
        "value": 211000,
        "children": [{
            "text": "白塔区",
            "value": 211002
        }, {
            "text": "文圣区",
            "value": 211003
        }, {
            "text": "宏伟区",
            "value": 211004
        }, {
            "text": "弓长岭区",
            "value": 211005
        }, {
            "text": "太子河区",
            "value": 211011
        }, {
            "text": "辽阳县",
            "value": 211021
        }, {
            "text": "灯塔市",
            "value": 211081
        }]
    }, {
        "text": "盘锦市",
        "value": 211100,
        "children": [{
            "text": "双台子区",
            "value": 211102
        }, {
            "text": "兴隆台区",
            "value": 211103
        }, {
            "text": "大洼区",
            "value": 211104
        }, {
            "text": "盘山县",
            "value": 211122
        }]
    }, {
        "text": "铁岭市",
        "value": 211200,
        "children": [{
            "text": "银州区",
            "value": 211202
        }, {
            "text": "清河区",
            "value": 211204
        }, {
            "text": "铁岭县",
            "value": 211221
        }, {
            "text": "西丰县",
            "value": 211223
        }, {
            "text": "昌图县",
            "value": 211224
        }, {
            "text": "调兵山市",
            "value": 211281
        }, {
            "text": "开原市",
            "value": 211282
        }]
    }, {
        "text": "朝阳市",
        "value": 211300,
        "children": [{
            "text": "双塔区",
            "value": 211302
        }, {
            "text": "龙城区",
            "value": 211303
        }, {
            "text": "朝阳县",
            "value": 211321
        }, {
            "text": "建平县",
            "value": 211322
        }, {
            "text": "喀喇沁左翼蒙古族自治县",
            "value": 211324
        }, {
            "text": "北票市",
            "value": 211381
        }, {
            "text": "凌源市",
            "value": 211382
        }]
    }, {
        "text": "葫芦岛市",
        "value": 211400,
        "children": [{
            "text": "连山区",
            "value": 211402
        }, {
            "text": "龙港区",
            "value": 211403
        }, {
            "text": "南票区",
            "value": 211404
        }, {
            "text": "绥中县",
            "value": 211421
        }, {
            "text": "建昌县",
            "value": 211422
        }, {
            "text": "兴城市",
            "value": 211481
        }]
    }]
}, {
    "text": "吉林省",
    "value": 220000,
    "children": [{
        "text": "长春市",
        "value": 220100,
        "children": [{
            "text": "南关区",
            "value": 220102
        }, {
            "text": "宽城区",
            "value": 220103
        }, {
            "text": "朝阳区",
            "value": 220104
        }, {
            "text": "二道区",
            "value": 220105
        }, {
            "text": "绿园区",
            "value": 220106
        }, {
            "text": "双阳区",
            "value": 220112
        }, {
            "text": "九台区",
            "value": 220113
        }, {
            "text": "农安县",
            "value": 220122
        }, {
            "text": "榆树市",
            "value": 220182
        }, {
            "text": "德惠市",
            "value": 220183
        }]
    }, {
        "text": "吉林市",
        "value": 220200,
        "children": [{
            "text": "昌邑区",
            "value": 220202
        }, {
            "text": "龙潭区",
            "value": 220203
        }, {
            "text": "船营区",
            "value": 220204
        }, {
            "text": "丰满区",
            "value": 220211
        }, {
            "text": "永吉县",
            "value": 220221
        }, {
            "text": "蛟河市",
            "value": 220281
        }, {
            "text": "桦甸市",
            "value": 220282
        }, {
            "text": "舒兰市",
            "value": 220283
        }, {
            "text": "磐石市",
            "value": 220284
        }]
    }, {
        "text": "四平市",
        "value": 220300,
        "children": [{
            "text": "铁西区",
            "value": 220302
        }, {
            "text": "铁东区",
            "value": 220303
        }, {
            "text": "梨树县",
            "value": 220322
        }, {
            "text": "伊通满族自治县",
            "value": 220323
        }, {
            "text": "公主岭市",
            "value": 220381
        }, {
            "text": "双辽市",
            "value": 220382
        }]
    }, {
        "text": "辽源市",
        "value": 220400,
        "children": [{
            "text": "龙山区",
            "value": 220402
        }, {
            "text": "西安区",
            "value": 220403
        }, {
            "text": "东丰县",
            "value": 220421
        }, {
            "text": "东辽县",
            "value": 220422
        }]
    }, {
        "text": "通化市",
        "value": 220500,
        "children": [{
            "text": "东昌区",
            "value": 220502
        }, {
            "text": "二道江区",
            "value": 220503
        }, {
            "text": "通化县",
            "value": 220521
        }, {
            "text": "辉南县",
            "value": 220523
        }, {
            "text": "柳河县",
            "value": 220524
        }, {
            "text": "梅河口市",
            "value": 220581
        }, {
            "text": "集安市",
            "value": 220582
        }]
    }, {
        "text": "白山市",
        "value": 220600,
        "children": [{
            "text": "浑江区",
            "value": 220602
        }, {
            "text": "江源区",
            "value": 220605
        }, {
            "text": "抚松县",
            "value": 220621
        }, {
            "text": "靖宇县",
            "value": 220622
        }, {
            "text": "长白朝鲜族自治县",
            "value": 220623
        }, {
            "text": "临江市",
            "value": 220681
        }]
    }, {
        "text": "松原市",
        "value": 220700,
        "children": [{
            "text": "宁江区",
            "value": 220702
        }, {
            "text": "前郭尔罗斯蒙古族自治县",
            "value": 220721
        }, {
            "text": "长岭县",
            "value": 220722
        }, {
            "text": "乾安县",
            "value": 220723
        }, {
            "text": "扶余市",
            "value": 220781
        }]
    }, {
        "text": "白城市",
        "value": 220800,
        "children": [{
            "text": "洮北区",
            "value": 220802
        }, {
            "text": "镇赉县",
            "value": 220821
        }, {
            "text": "通榆县",
            "value": 220822
        }, {
            "text": "洮南市",
            "value": 220881
        }, {
            "text": "大安市",
            "value": 220882
        }]
    }, {
        "text": "延边朝鲜族自治州",
        "value": 222400,
        "children": [{
            "text": "延吉市",
            "value": 222401
        }, {
            "text": "图们市",
            "value": 222402
        }, {
            "text": "敦化市",
            "value": 222403
        }, {
            "text": "珲春市",
            "value": 222404
        }, {
            "text": "龙井市",
            "value": 222405
        }, {
            "text": "和龙市",
            "value": 222406
        }, {
            "text": "汪清县",
            "value": 222424
        }, {
            "text": "安图县",
            "value": 222426
        }]
    }]
}, {
    "text": "黑龙江省",
    "value": 230000,
    "children": [{
        "text": "哈尔滨市",
        "value": 230100,
        "children": [{
            "text": "道里区",
            "value": 230102
        }, {
            "text": "南岗区",
            "value": 230103
        }, {
            "text": "道外区",
            "value": 230104
        }, {
            "text": "平房区",
            "value": 230108
        }, {
            "text": "松北区",
            "value": 230109
        }, {
            "text": "香坊区",
            "value": 230110
        }, {
            "text": "呼兰区",
            "value": 230111
        }, {
            "text": "阿城区",
            "value": 230112
        }, {
            "text": "双城区",
            "value": 230113
        }, {
            "text": "依兰县",
            "value": 230123
        }, {
            "text": "方正县",
            "value": 230124
        }, {
            "text": "宾县",
            "value": 230125
        }, {
            "text": "巴彦县",
            "value": 230126
        }, {
            "text": "木兰县",
            "value": 230127
        }, {
            "text": "通河县",
            "value": 230128
        }, {
            "text": "延寿县",
            "value": 230129
        }, {
            "text": "尚志市",
            "value": 230183
        }, {
            "text": "五常市",
            "value": 230184
        }]
    }, {
        "text": "齐齐哈尔市",
        "value": 230200,
        "children": [{
            "text": "龙沙区",
            "value": 230202
        }, {
            "text": "建华区",
            "value": 230203
        }, {
            "text": "铁锋区",
            "value": 230204
        }, {
            "text": "昂昂溪区",
            "value": 230205
        }, {
            "text": "富拉尔基区",
            "value": 230206
        }, {
            "text": "碾子山区",
            "value": 230207
        }, {
            "text": "梅里斯达斡尔族区",
            "value": 230208
        }, {
            "text": "龙江县",
            "value": 230221
        }, {
            "text": "依安县",
            "value": 230223
        }, {
            "text": "泰来县",
            "value": 230224
        }, {
            "text": "甘南县",
            "value": 230225
        }, {
            "text": "富裕县",
            "value": 230227
        }, {
            "text": "克山县",
            "value": 230229
        }, {
            "text": "克东县",
            "value": 230230
        }, {
            "text": "拜泉县",
            "value": 230231
        }, {
            "text": "讷河市",
            "value": 230281
        }]
    }, {
        "text": "鸡西市",
        "value": 230300,
        "children": [{
            "text": "鸡冠区",
            "value": 230302
        }, {
            "text": "恒山区",
            "value": 230303
        }, {
            "text": "滴道区",
            "value": 230304
        }, {
            "text": "梨树区",
            "value": 230305
        }, {
            "text": "城子河区",
            "value": 230306
        }, {
            "text": "麻山区",
            "value": 230307
        }, {
            "text": "鸡东县",
            "value": 230321
        }, {
            "text": "虎林市",
            "value": 230381
        }, {
            "text": "密山市",
            "value": 230382
        }]
    }, {
        "text": "鹤岗市",
        "value": 230400,
        "children": [{
            "text": "向阳区",
            "value": 230402
        }, {
            "text": "工农区",
            "value": 230403
        }, {
            "text": "南山区",
            "value": 230404
        }, {
            "text": "兴安区",
            "value": 230405
        }, {
            "text": "东山区",
            "value": 230406
        }, {
            "text": "兴山区",
            "value": 230407
        }, {
            "text": "萝北县",
            "value": 230421
        }, {
            "text": "绥滨县",
            "value": 230422
        }]
    }, {
        "text": "双鸭山市",
        "value": 230500,
        "children": [{
            "text": "尖山区",
            "value": 230502
        }, {
            "text": "岭东区",
            "value": 230503
        }, {
            "text": "四方台区",
            "value": 230505
        }, {
            "text": "宝山区",
            "value": 230506
        }, {
            "text": "集贤县",
            "value": 230521
        }, {
            "text": "友谊县",
            "value": 230522
        }, {
            "text": "宝清县",
            "value": 230523
        }, {
            "text": "饶河县",
            "value": 230524
        }]
    }, {
        "text": "大庆市",
        "value": 230600,
        "children": [{
            "text": "萨尔图区",
            "value": 230602
        }, {
            "text": "龙凤区",
            "value": 230603
        }, {
            "text": "让胡路区",
            "value": 230604
        }, {
            "text": "红岗区",
            "value": 230605
        }, {
            "text": "大同区",
            "value": 230606
        }, {
            "text": "肇州县",
            "value": 230621
        }, {
            "text": "肇源县",
            "value": 230622
        }, {
            "text": "林甸县",
            "value": 230623
        }, {
            "text": "杜尔伯特蒙古族自治县",
            "value": 230624
        }]
    }, {
        "text": "伊春市",
        "value": 230700,
        "children": [{
            "text": "伊美区",
            "value": 230717
        }, {
            "text": "乌翠区",
            "value": 230718
        }, {
            "text": "友好区",
            "value": 230719
        }, {
            "text": "嘉荫县",
            "value": 230722
        }, {
            "text": "汤旺县",
            "value": 230723
        }, {
            "text": "丰林县",
            "value": 230724
        }, {
            "text": "大箐山县",
            "value": 230725
        }, {
            "text": "南岔县",
            "value": 230726
        }, {
            "text": "金林区",
            "value": 230751
        }, {
            "text": "铁力市",
            "value": 230781
        }]
    }, {
        "text": "佳木斯市",
        "value": 230800,
        "children": [{
            "text": "向阳区",
            "value": 230803
        }, {
            "text": "前进区",
            "value": 230804
        }, {
            "text": "东风区",
            "value": 230805
        }, {
            "text": "郊区",
            "value": 230811
        }, {
            "text": "桦南县",
            "value": 230822
        }, {
            "text": "桦川县",
            "value": 230826
        }, {
            "text": "汤原县",
            "value": 230828
        }, {
            "text": "同江市",
            "value": 230881
        }, {
            "text": "富锦市",
            "value": 230882
        }, {
            "text": "抚远市",
            "value": 230883
        }]
    }, {
        "text": "七台河市",
        "value": 230900,
        "children": [{
            "text": "新兴区",
            "value": 230902
        }, {
            "text": "桃山区",
            "value": 230903
        }, {
            "text": "茄子河区",
            "value": 230904
        }, {
            "text": "勃利县",
            "value": 230921
        }]
    }, {
        "text": "牡丹江市",
        "value": 231000,
        "children": [{
            "text": "东安区",
            "value": 231002
        }, {
            "text": "阳明区",
            "value": 231003
        }, {
            "text": "爱民区",
            "value": 231004
        }, {
            "text": "西安区",
            "value": 231005
        }, {
            "text": "林口县",
            "value": 231025
        }, {
            "text": "绥芬河市",
            "value": 231081
        }, {
            "text": "海林市",
            "value": 231083
        }, {
            "text": "宁安市",
            "value": 231084
        }, {
            "text": "穆棱市",
            "value": 231085
        }, {
            "text": "东宁市",
            "value": 231086
        }]
    }, {
        "text": "黑河市",
        "value": 231100,
        "children": [{
            "text": "爱辉区",
            "value": 231102
        }, {
            "text": "逊克县",
            "value": 231123
        }, {
            "text": "孙吴县",
            "value": 231124
        }, {
            "text": "北安市",
            "value": 231181
        }, {
            "text": "五大连池市",
            "value": 231182
        }, {
            "text": "嫩江市",
            "value": 231183
        }]
    }, {
        "text": "绥化市",
        "value": 231200,
        "children": [{
            "text": "北林区",
            "value": 231202
        }, {
            "text": "望奎县",
            "value": 231221
        }, {
            "text": "兰西县",
            "value": 231222
        }, {
            "text": "青冈县",
            "value": 231223
        }, {
            "text": "庆安县",
            "value": 231224
        }, {
            "text": "明水县",
            "value": 231225
        }, {
            "text": "绥棱县",
            "value": 231226
        }, {
            "text": "安达市",
            "value": 231281
        }, {
            "text": "肇东市",
            "value": 231282
        }, {
            "text": "海伦市",
            "value": 231283
        }]
    }, {
        "text": "大兴安岭地区",
        "value": 232700,
        "children": [{
            "text": "漠河市",
            "value": 232701
        }, {
            "text": "加格达奇区",
            "value": 232718
        }, {
            "text": "呼玛县",
            "value": 232721
        }, {
            "text": "塔河县",
            "value": 232722
        }]
    }]
}, {
    "text": "上海",
    "value": 310000,
    "children": [{
        "text": "上海市",
        "value": 310100,
        "children": [{
            "text": "黄浦区",
            "value": 310101
        }, {
            "text": "徐汇区",
            "value": 310104
        }, {
            "text": "长宁区",
            "value": 310105
        }, {
            "text": "静安区",
            "value": 310106
        }, {
            "text": "普陀区",
            "value": 310107
        }, {
            "text": "虹口区",
            "value": 310109
        }, {
            "text": "杨浦区",
            "value": 310110
        }, {
            "text": "闵行区",
            "value": 310112
        }, {
            "text": "宝山区",
            "value": 310113
        }, {
            "text": "嘉定区",
            "value": 310114
        }, {
            "text": "浦东新区",
            "value": 310115
        }, {
            "text": "金山区",
            "value": 310116
        }, {
            "text": "松江区",
            "value": 310117
        }, {
            "text": "青浦区",
            "value": 310118
        }, {
            "text": "奉贤区",
            "value": 310120
        }, {
            "text": "崇明区",
            "value": 310151
        }]
    }]
}, {
    "text": "江苏省",
    "value": 320000,
    "children": [{
        "text": "南京市",
        "value": 320100,
        "children": [{
            "text": "玄武区",
            "value": 320102
        }, {
            "text": "秦淮区",
            "value": 320104
        }, {
            "text": "建邺区",
            "value": 320105
        }, {
            "text": "鼓楼区",
            "value": 320106
        }, {
            "text": "浦口区",
            "value": 320111
        }, {
            "text": "栖霞区",
            "value": 320113
        }, {
            "text": "雨花台区",
            "value": 320114
        }, {
            "text": "江宁区",
            "value": 320115
        }, {
            "text": "六合区",
            "value": 320116
        }, {
            "text": "溧水区",
            "value": 320117
        }, {
            "text": "高淳区",
            "value": 320118
        }]
    }, {
        "text": "无锡市",
        "value": 320200,
        "children": [{
            "text": "锡山区",
            "value": 320205
        }, {
            "text": "惠山区",
            "value": 320206
        }, {
            "text": "滨湖区",
            "value": 320211
        }, {
            "text": "梁溪区",
            "value": 320213
        }, {
            "text": "新吴区",
            "value": 320214
        }, {
            "text": "江阴市",
            "value": 320281
        }, {
            "text": "宜兴市",
            "value": 320282
        }]
    }, {
        "text": "徐州市",
        "value": 320300,
        "children": [{
            "text": "鼓楼区",
            "value": 320302
        }, {
            "text": "云龙区",
            "value": 320303
        }, {
            "text": "贾汪区",
            "value": 320305
        }, {
            "text": "泉山区",
            "value": 320311
        }, {
            "text": "铜山区",
            "value": 320312
        }, {
            "text": "丰县",
            "value": 320321
        }, {
            "text": "沛县",
            "value": 320322
        }, {
            "text": "睢宁县",
            "value": 320324
        }, {
            "text": "新沂市",
            "value": 320381
        }, {
            "text": "邳州市",
            "value": 320382
        }]
    }, {
        "text": "常州市",
        "value": 320400,
        "children": [{
            "text": "天宁区",
            "value": 320402
        }, {
            "text": "钟楼区",
            "value": 320404
        }, {
            "text": "新北区",
            "value": 320411
        }, {
            "text": "武进区",
            "value": 320412
        }, {
            "text": "金坛区",
            "value": 320413
        }, {
            "text": "溧阳市",
            "value": 320481
        }]
    }, {
        "text": "苏州市",
        "value": 320500,
        "children": [{
            "text": "虎丘区",
            "value": 320505
        }, {
            "text": "吴中区",
            "value": 320506
        }, {
            "text": "相城区",
            "value": 320507
        }, {
            "text": "姑苏区",
            "value": 320508
        }, {
            "text": "吴江区",
            "value": 320509
        }, {
            "text": "苏州工业园区",
            "value": 320571
        }, {
            "text": "常熟市",
            "value": 320581
        }, {
            "text": "张家港市",
            "value": 320582
        }, {
            "text": "昆山市",
            "value": 320583
        }, {
            "text": "太仓市",
            "value": 320585
        }]
    }, {
        "text": "南通市",
        "value": 320600,
        "children": [{
            "text": "崇川区",
            "value": 320602
        }, {
            "text": "港闸区",
            "value": 320611
        }, {
            "text": "通州区",
            "value": 320612
        }, {
            "text": "如东县",
            "value": 320623
        }, {
            "text": "启东市",
            "value": 320681
        }, {
            "text": "如皋市",
            "value": 320682
        }, {
            "text": "海门市",
            "value": 320684
        }, {
            "text": "海安市",
            "value": 320685
        }]
    }, {
        "text": "连云港市",
        "value": 320700,
        "children": [{
            "text": "连云区",
            "value": 320703
        }, {
            "text": "海州区",
            "value": 320706
        }, {
            "text": "赣榆区",
            "value": 320707
        }, {
            "text": "东海县",
            "value": 320722
        }, {
            "text": "灌云县",
            "value": 320723
        }, {
            "text": "灌南县",
            "value": 320724
        }]
    }, {
        "text": "淮安市",
        "value": 320800,
        "children": [{
            "text": "淮安区",
            "value": 320803
        }, {
            "text": "淮阴区",
            "value": 320804
        }, {
            "text": "清江浦区",
            "value": 320812
        }, {
            "text": "洪泽区",
            "value": 320813
        }, {
            "text": "涟水县",
            "value": 320826
        }, {
            "text": "盱眙县",
            "value": 320830
        }, {
            "text": "金湖县",
            "value": 320831
        }]
    }, {
        "text": "盐城市",
        "value": 320900,
        "children": [{
            "text": "亭湖区",
            "value": 320902
        }, {
            "text": "盐都区",
            "value": 320903
        }, {
            "text": "大丰区",
            "value": 320904
        }, {
            "text": "响水县",
            "value": 320921
        }, {
            "text": "滨海县",
            "value": 320922
        }, {
            "text": "阜宁县",
            "value": 320923
        }, {
            "text": "射阳县",
            "value": 320924
        }, {
            "text": "建湖县",
            "value": 320925
        }, {
            "text": "东台市",
            "value": 320981
        }]
    }, {
        "text": "扬州市",
        "value": 321000,
        "children": [{
            "text": "广陵区",
            "value": 321002
        }, {
            "text": "邗江区",
            "value": 321003
        }, {
            "text": "江都区",
            "value": 321012
        }, {
            "text": "宝应县",
            "value": 321023
        }, {
            "text": "仪征市",
            "value": 321081
        }, {
            "text": "高邮市",
            "value": 321084
        }]
    }, {
        "text": "镇江市",
        "value": 321100,
        "children": [{
            "text": "京口区",
            "value": 321102
        }, {
            "text": "润州区",
            "value": 321111
        }, {
            "text": "丹徒区",
            "value": 321112
        }, {
            "text": "丹阳市",
            "value": 321181
        }, {
            "text": "扬中市",
            "value": 321182
        }, {
            "text": "句容市",
            "value": 321183
        }]
    }, {
        "text": "泰州市",
        "value": 321200,
        "children": [{
            "text": "海陵区",
            "value": 321202
        }, {
            "text": "高港区",
            "value": 321203
        }, {
            "text": "姜堰区",
            "value": 321204
        }, {
            "text": "兴化市",
            "value": 321281
        }, {
            "text": "靖江市",
            "value": 321282
        }, {
            "text": "泰兴市",
            "value": 321283
        }]
    }, {
        "text": "宿迁市",
        "value": 321300,
        "children": [{
            "text": "宿城区",
            "value": 321302
        }, {
            "text": "宿豫区",
            "value": 321311
        }, {
            "text": "沭阳县",
            "value": 321322
        }, {
            "text": "泗阳县",
            "value": 321323
        }, {
            "text": "泗洪县",
            "value": 321324
        }]
    }]
}, {
    "text": "浙江省",
    "value": 330000,
    "children": [{
        "text": "杭州市",
        "value": 330100,
        "children": [{
            "text": "上城区",
            "value": 330102
        }, {
            "text": "下城区",
            "value": 330103
        }, {
            "text": "江干区",
            "value": 330104
        }, {
            "text": "拱墅区",
            "value": 330105
        }, {
            "text": "西湖区",
            "value": 330106
        }, {
            "text": "滨江区",
            "value": 330108
        }, {
            "text": "萧山区",
            "value": 330109
        }, {
            "text": "余杭区",
            "value": 330110
        }, {
            "text": "富阳区",
            "value": 330111
        }, {
            "text": "临安区",
            "value": 330112
        }, {
            "text": "桐庐县",
            "value": 330122
        }, {
            "text": "淳安县",
            "value": 330127
        }, {
            "text": "建德市",
            "value": 330182
        }]
    }, {
        "text": "宁波市",
        "value": 330200,
        "children": [{
            "text": "海曙区",
            "value": 330203
        }, {
            "text": "江北区",
            "value": 330205
        }, {
            "text": "北仑区",
            "value": 330206
        }, {
            "text": "镇海区",
            "value": 330211
        }, {
            "text": "鄞州区",
            "value": 330212
        }, {
            "text": "奉化区",
            "value": 330213
        }, {
            "text": "象山县",
            "value": 330225
        }, {
            "text": "宁海县",
            "value": 330226
        }, {
            "text": "余姚市",
            "value": 330281
        }, {
            "text": "慈溪市",
            "value": 330282
        }]
    }, {
        "text": "温州市",
        "value": 330300,
        "children": [{
            "text": "鹿城区",
            "value": 330302
        }, {
            "text": "龙湾区",
            "value": 330303
        }, {
            "text": "瓯海区",
            "value": 330304
        }, {
            "text": "洞头区",
            "value": 330305
        }, {
            "text": "永嘉县",
            "value": 330324
        }, {
            "text": "平阳县",
            "value": 330326
        }, {
            "text": "苍南县",
            "value": 330327
        }, {
            "text": "文成县",
            "value": 330328
        }, {
            "text": "泰顺县",
            "value": 330329
        }, {
            "text": "瑞安市",
            "value": 330381
        }, {
            "text": "乐清市",
            "value": 330382
        }, {
            "text": "龙港市",
            "value": 330383
        }]
    }, {
        "text": "嘉兴市",
        "value": 330400,
        "children": [{
            "text": "南湖区",
            "value": 330402
        }, {
            "text": "秀洲区",
            "value": 330411
        }, {
            "text": "嘉善县",
            "value": 330421
        }, {
            "text": "海盐县",
            "value": 330424
        }, {
            "text": "海宁市",
            "value": 330481
        }, {
            "text": "平湖市",
            "value": 330482
        }, {
            "text": "桐乡市",
            "value": 330483
        }]
    }, {
        "text": "湖州市",
        "value": 330500,
        "children": [{
            "text": "吴兴区",
            "value": 330502
        }, {
            "text": "南浔区",
            "value": 330503
        }, {
            "text": "德清县",
            "value": 330521
        }, {
            "text": "长兴县",
            "value": 330522
        }, {
            "text": "安吉县",
            "value": 330523
        }]
    }, {
        "text": "绍兴市",
        "value": 330600,
        "children": [{
            "text": "越城区",
            "value": 330602
        }, {
            "text": "柯桥区",
            "value": 330603
        }, {
            "text": "上虞区",
            "value": 330604
        }, {
            "text": "新昌县",
            "value": 330624
        }, {
            "text": "诸暨市",
            "value": 330681
        }, {
            "text": "嵊州市",
            "value": 330683
        }]
    }, {
        "text": "金华市",
        "value": 330700,
        "children": [{
            "text": "婺城区",
            "value": 330702
        }, {
            "text": "金东区",
            "value": 330703
        }, {
            "text": "武义县",
            "value": 330723
        }, {
            "text": "浦江县",
            "value": 330726
        }, {
            "text": "磐安县",
            "value": 330727
        }, {
            "text": "兰溪市",
            "value": 330781
        }, {
            "text": "义乌市",
            "value": 330782
        }, {
            "text": "东阳市",
            "value": 330783
        }, {
            "text": "永康市",
            "value": 330784
        }]
    }, {
        "text": "衢州市",
        "value": 330800,
        "children": [{
            "text": "柯城区",
            "value": 330802
        }, {
            "text": "衢江区",
            "value": 330803
        }, {
            "text": "常山县",
            "value": 330822
        }, {
            "text": "开化县",
            "value": 330824
        }, {
            "text": "龙游县",
            "value": 330825
        }, {
            "text": "江山市",
            "value": 330881
        }]
    }, {
        "text": "舟山市",
        "value": 330900,
        "children": [{
            "text": "定海区",
            "value": 330902
        }, {
            "text": "普陀区",
            "value": 330903
        }, {
            "text": "岱山县",
            "value": 330921
        }, {
            "text": "嵊泗县",
            "value": 330922
        }]
    }, {
        "text": "台州市",
        "value": 331000,
        "children": [{
            "text": "椒江区",
            "value": 331002
        }, {
            "text": "黄岩区",
            "value": 331003
        }, {
            "text": "路桥区",
            "value": 331004
        }, {
            "text": "三门县",
            "value": 331022
        }, {
            "text": "天台县",
            "value": 331023
        }, {
            "text": "仙居县",
            "value": 331024
        }, {
            "text": "温岭市",
            "value": 331081
        }, {
            "text": "临海市",
            "value": 331082
        }, {
            "text": "玉环市",
            "value": 331083
        }]
    }, {
        "text": "丽水市",
        "value": 331100,
        "children": [{
            "text": "莲都区",
            "value": 331102
        }, {
            "text": "青田县",
            "value": 331121
        }, {
            "text": "缙云县",
            "value": 331122
        }, {
            "text": "遂昌县",
            "value": 331123
        }, {
            "text": "松阳县",
            "value": 331124
        }, {
            "text": "云和县",
            "value": 331125
        }, {
            "text": "庆元县",
            "value": 331126
        }, {
            "text": "景宁畲族自治县",
            "value": 331127
        }, {
            "text": "龙泉市",
            "value": 331181
        }]
    }]
}, {
    "text": "安徽省",
    "value": 340000,
    "children": [{
        "text": "合肥市",
        "value": 340100,
        "children": [{
            "text": "瑶海区",
            "value": 340102
        }, {
            "text": "庐阳区",
            "value": 340103
        }, {
            "text": "蜀山区",
            "value": 340104
        }, {
            "text": "包河区",
            "value": 340111
        }, {
            "text": "长丰县",
            "value": 340121
        }, {
            "text": "肥东县",
            "value": 340122
        }, {
            "text": "肥西县",
            "value": 340123
        }, {
            "text": "庐江县",
            "value": 340124
        }, {
            "text": "巢湖市",
            "value": 340181
        }]
    }, {
        "text": "芜湖市",
        "value": 340200,
        "children": [{
            "text": "镜湖区",
            "value": 340202
        }, {
            "text": "弋江区",
            "value": 340203
        }, {
            "text": "鸠江区",
            "value": 340207
        }, {
            "text": "三山区",
            "value": 340208
        }, {
            "text": "芜湖县",
            "value": 340221
        }, {
            "text": "繁昌县",
            "value": 340222
        }, {
            "text": "南陵县",
            "value": 340223
        }, {
            "text": "无为市",
            "value": 340281
        }]
    }, {
        "text": "蚌埠市",
        "value": 340300,
        "children": [{
            "text": "龙子湖区",
            "value": 340302
        }, {
            "text": "蚌山区",
            "value": 340303
        }, {
            "text": "禹会区",
            "value": 340304
        }, {
            "text": "淮上区",
            "value": 340311
        }, {
            "text": "怀远县",
            "value": 340321
        }, {
            "text": "五河县",
            "value": 340322
        }, {
            "text": "固镇县",
            "value": 340323
        }]
    }, {
        "text": "淮南市",
        "value": 340400,
        "children": [{
            "text": "大通区",
            "value": 340402
        }, {
            "text": "田家庵区",
            "value": 340403
        }, {
            "text": "谢家集区",
            "value": 340404
        }, {
            "text": "八公山区",
            "value": 340405
        }, {
            "text": "潘集区",
            "value": 340406
        }, {
            "text": "凤台县",
            "value": 340421
        }, {
            "text": "寿县",
            "value": 340422
        }]
    }, {
        "text": "马鞍山市",
        "value": 340500,
        "children": [{
            "text": "花山区",
            "value": 340503
        }, {
            "text": "雨山区",
            "value": 340504
        }, {
            "text": "博望区",
            "value": 340506
        }, {
            "text": "当涂县",
            "value": 340521
        }, {
            "text": "含山县",
            "value": 340522
        }, {
            "text": "和县",
            "value": 340523
        }]
    }, {
        "text": "淮北市",
        "value": 340600,
        "children": [{
            "text": "杜集区",
            "value": 340602
        }, {
            "text": "相山区",
            "value": 340603
        }, {
            "text": "烈山区",
            "value": 340604
        }, {
            "text": "濉溪县",
            "value": 340621
        }]
    }, {
        "text": "铜陵市",
        "value": 340700,
        "children": [{
            "text": "铜官区",
            "value": 340705
        }, {
            "text": "义安区",
            "value": 340706
        }, {
            "text": "郊区",
            "value": 340711
        }, {
            "text": "枞阳县",
            "value": 340722
        }]
    }, {
        "text": "安庆市",
        "value": 340800,
        "children": [{
            "text": "迎江区",
            "value": 340802
        }, {
            "text": "大观区",
            "value": 340803
        }, {
            "text": "宜秀区",
            "value": 340811
        }, {
            "text": "怀宁县",
            "value": 340822
        }, {
            "text": "太湖县",
            "value": 340825
        }, {
            "text": "宿松县",
            "value": 340826
        }, {
            "text": "望江县",
            "value": 340827
        }, {
            "text": "岳西县",
            "value": 340828
        }, {
            "text": "桐城市",
            "value": 340881
        }, {
            "text": "潜山市",
            "value": 340882
        }]
    }, {
        "text": "黄山市",
        "value": 341000,
        "children": [{
            "text": "屯溪区",
            "value": 341002
        }, {
            "text": "黄山区",
            "value": 341003
        }, {
            "text": "徽州区",
            "value": 341004
        }, {
            "text": "歙县",
            "value": 341021
        }, {
            "text": "休宁县",
            "value": 341022
        }, {
            "text": "黟县",
            "value": 341023
        }, {
            "text": "祁门县",
            "value": 341024
        }]
    }, {
        "text": "滁州市",
        "value": 341100,
        "children": [{
            "text": "琅琊区",
            "value": 341102
        }, {
            "text": "南谯区",
            "value": 341103
        }, {
            "text": "来安县",
            "value": 341122
        }, {
            "text": "全椒县",
            "value": 341124
        }, {
            "text": "定远县",
            "value": 341125
        }, {
            "text": "凤阳县",
            "value": 341126
        }, {
            "text": "天长市",
            "value": 341181
        }, {
            "text": "明光市",
            "value": 341182
        }]
    }, {
        "text": "阜阳市",
        "value": 341200,
        "children": [{
            "text": "颍州区",
            "value": 341202
        }, {
            "text": "颍东区",
            "value": 341203
        }, {
            "text": "颍泉区",
            "value": 341204
        }, {
            "text": "临泉县",
            "value": 341221
        }, {
            "text": "太和县",
            "value": 341222
        }, {
            "text": "阜南县",
            "value": 341225
        }, {
            "text": "颍上县",
            "value": 341226
        }, {
            "text": "界首市",
            "value": 341282
        }]
    }, {
        "text": "宿州市",
        "value": 341300,
        "children": [{
            "text": "埇桥区",
            "value": 341302
        }, {
            "text": "砀山县",
            "value": 341321
        }, {
            "text": "萧县",
            "value": 341322
        }, {
            "text": "灵璧县",
            "value": 341323
        }, {
            "text": "泗县",
            "value": 341324
        }]
    }, {
        "text": "六安市",
        "value": 341500,
        "children": [{
            "text": "金安区",
            "value": 341502
        }, {
            "text": "裕安区",
            "value": 341503
        }, {
            "text": "叶集区",
            "value": 341504
        }, {
            "text": "霍邱县",
            "value": 341522
        }, {
            "text": "舒城县",
            "value": 341523
        }, {
            "text": "金寨县",
            "value": 341524
        }, {
            "text": "霍山县",
            "value": 341525
        }]
    }, {
        "text": "亳州市",
        "value": 341600,
        "children": [{
            "text": "谯城区",
            "value": 341602
        }, {
            "text": "涡阳县",
            "value": 341621
        }, {
            "text": "蒙城县",
            "value": 341622
        }, {
            "text": "利辛县",
            "value": 341623
        }]
    }, {
        "text": "池州市",
        "value": 341700,
        "children": [{
            "text": "贵池区",
            "value": 341702
        }, {
            "text": "东至县",
            "value": 341721
        }, {
            "text": "石台县",
            "value": 341722
        }, {
            "text": "青阳县",
            "value": 341723
        }]
    }, {
        "text": "宣城市",
        "value": 341800,
        "children": [{
            "text": "宣州区",
            "value": 341802
        }, {
            "text": "郎溪县",
            "value": 341821
        }, {
            "text": "泾县",
            "value": 341823
        }, {
            "text": "绩溪县",
            "value": 341824
        }, {
            "text": "旌德县",
            "value": 341825
        }, {
            "text": "宁国市",
            "value": 341881
        }, {
            "text": "广德市",
            "value": 341882
        }]
    }]
}, {
    "text": "福建省",
    "value": 350000,
    "children": [{
        "text": "福州市",
        "value": 350100,
        "children": [{
            "text": "鼓楼区",
            "value": 350102
        }, {
            "text": "台江区",
            "value": 350103
        }, {
            "text": "仓山区",
            "value": 350104
        }, {
            "text": "马尾区",
            "value": 350105
        }, {
            "text": "晋安区",
            "value": 350111
        }, {
            "text": "长乐区",
            "value": 350112
        }, {
            "text": "闽侯县",
            "value": 350121
        }, {
            "text": "连江县",
            "value": 350122
        }, {
            "text": "罗源县",
            "value": 350123
        }, {
            "text": "闽清县",
            "value": 350124
        }, {
            "text": "永泰县",
            "value": 350125
        }, {
            "text": "平潭县",
            "value": 350128
        }, {
            "text": "福清市",
            "value": 350181
        }]
    }, {
        "text": "厦门市",
        "value": 350200,
        "children": [{
            "text": "思明区",
            "value": 350203
        }, {
            "text": "海沧区",
            "value": 350205
        }, {
            "text": "湖里区",
            "value": 350206
        }, {
            "text": "集美区",
            "value": 350211
        }, {
            "text": "同安区",
            "value": 350212
        }, {
            "text": "翔安区",
            "value": 350213
        }]
    }, {
        "text": "莆田市",
        "value": 350300,
        "children": [{
            "text": "城厢区",
            "value": 350302
        }, {
            "text": "涵江区",
            "value": 350303
        }, {
            "text": "荔城区",
            "value": 350304
        }, {
            "text": "秀屿区",
            "value": 350305
        }, {
            "text": "仙游县",
            "value": 350322
        }]
    }, {
        "text": "三明市",
        "value": 350400,
        "children": [{
            "text": "梅列区",
            "value": 350402
        }, {
            "text": "三元区",
            "value": 350403
        }, {
            "text": "明溪县",
            "value": 350421
        }, {
            "text": "清流县",
            "value": 350423
        }, {
            "text": "宁化县",
            "value": 350424
        }, {
            "text": "大田县",
            "value": 350425
        }, {
            "text": "尤溪县",
            "value": 350426
        }, {
            "text": "沙县",
            "value": 350427
        }, {
            "text": "将乐县",
            "value": 350428
        }, {
            "text": "泰宁县",
            "value": 350429
        }, {
            "text": "建宁县",
            "value": 350430
        }, {
            "text": "永安市",
            "value": 350481
        }]
    }, {
        "text": "泉州市",
        "value": 350500,
        "children": [{
            "text": "鲤城区",
            "value": 350502
        }, {
            "text": "丰泽区",
            "value": 350503
        }, {
            "text": "洛江区",
            "value": 350504
        }, {
            "text": "泉港区",
            "value": 350505
        }, {
            "text": "惠安县",
            "value": 350521
        }, {
            "text": "安溪县",
            "value": 350524
        }, {
            "text": "永春县",
            "value": 350525
        }, {
            "text": "德化县",
            "value": 350526
        }, {
            "text": "金门县",
            "value": 350527
        }, {
            "text": "石狮市",
            "value": 350581
        }, {
            "text": "晋江市",
            "value": 350582
        }, {
            "text": "南安市",
            "value": 350583
        }]
    }, {
        "text": "漳州市",
        "value": 350600,
        "children": [{
            "text": "芗城区",
            "value": 350602
        }, {
            "text": "龙文区",
            "value": 350603
        }, {
            "text": "云霄县",
            "value": 350622
        }, {
            "text": "漳浦县",
            "value": 350623
        }, {
            "text": "诏安县",
            "value": 350624
        }, {
            "text": "长泰县",
            "value": 350625
        }, {
            "text": "东山县",
            "value": 350626
        }, {
            "text": "南靖县",
            "value": 350627
        }, {
            "text": "平和县",
            "value": 350628
        }, {
            "text": "华安县",
            "value": 350629
        }, {
            "text": "龙海市",
            "value": 350681
        }]
    }, {
        "text": "南平市",
        "value": 350700,
        "children": [{
            "text": "延平区",
            "value": 350702
        }, {
            "text": "建阳区",
            "value": 350703
        }, {
            "text": "顺昌县",
            "value": 350721
        }, {
            "text": "浦城县",
            "value": 350722
        }, {
            "text": "光泽县",
            "value": 350723
        }, {
            "text": "松溪县",
            "value": 350724
        }, {
            "text": "政和县",
            "value": 350725
        }, {
            "text": "邵武市",
            "value": 350781
        }, {
            "text": "武夷山市",
            "value": 350782
        }, {
            "text": "建瓯市",
            "value": 350783
        }]
    }, {
        "text": "龙岩市",
        "value": 350800,
        "children": [{
            "text": "新罗区",
            "value": 350802
        }, {
            "text": "永定区",
            "value": 350803
        }, {
            "text": "长汀县",
            "value": 350821
        }, {
            "text": "上杭县",
            "value": 350823
        }, {
            "text": "武平县",
            "value": 350824
        }, {
            "text": "连城县",
            "value": 350825
        }, {
            "text": "漳平市",
            "value": 350881
        }]
    }, {
        "text": "宁德市",
        "value": 350900,
        "children": [{
            "text": "蕉城区",
            "value": 350902
        }, {
            "text": "霞浦县",
            "value": 350921
        }, {
            "text": "古田县",
            "value": 350922
        }, {
            "text": "屏南县",
            "value": 350923
        }, {
            "text": "寿宁县",
            "value": 350924
        }, {
            "text": "周宁县",
            "value": 350925
        }, {
            "text": "柘荣县",
            "value": 350926
        }, {
            "text": "福安市",
            "value": 350981
        }, {
            "text": "福鼎市",
            "value": 350982
        }]
    }]
}, {
    "text": "江西省",
    "value": 360000,
    "children": [{
        "text": "南昌市",
        "value": 360100,
        "children": [{
            "text": "东湖区",
            "value": 360102
        }, {
            "text": "西湖区",
            "value": 360103
        }, {
            "text": "青云谱区",
            "value": 360104
        }, {
            "text": "青山湖区",
            "value": 360111
        }, {
            "text": "新建区",
            "value": 360112
        }, {
            "text": "红谷滩区",
            "value": 360113
        }, {
            "text": "南昌县",
            "value": 360121
        }, {
            "text": "安义县",
            "value": 360123
        }, {
            "text": "进贤县",
            "value": 360124
        }]
    }, {
        "text": "景德镇市",
        "value": 360200,
        "children": [{
            "text": "昌江区",
            "value": 360202
        }, {
            "text": "珠山区",
            "value": 360203
        }, {
            "text": "浮梁县",
            "value": 360222
        }, {
            "text": "乐平市",
            "value": 360281
        }]
    }, {
        "text": "萍乡市",
        "value": 360300,
        "children": [{
            "text": "安源区",
            "value": 360302
        }, {
            "text": "湘东区",
            "value": 360313
        }, {
            "text": "莲花县",
            "value": 360321
        }, {
            "text": "上栗县",
            "value": 360322
        }, {
            "text": "芦溪县",
            "value": 360323
        }]
    }, {
        "text": "九江市",
        "value": 360400,
        "children": [{
            "text": "濂溪区",
            "value": 360402
        }, {
            "text": "浔阳区",
            "value": 360403
        }, {
            "text": "柴桑区",
            "value": 360404
        }, {
            "text": "武宁县",
            "value": 360423
        }, {
            "text": "修水县",
            "value": 360424
        }, {
            "text": "永修县",
            "value": 360425
        }, {
            "text": "德安县",
            "value": 360426
        }, {
            "text": "都昌县",
            "value": 360428
        }, {
            "text": "湖口县",
            "value": 360429
        }, {
            "text": "彭泽县",
            "value": 360430
        }, {
            "text": "瑞昌市",
            "value": 360481
        }, {
            "text": "共青城市",
            "value": 360482
        }, {
            "text": "庐山市",
            "value": 360483
        }]
    }, {
        "text": "新余市",
        "value": 360500,
        "children": [{
            "text": "渝水区",
            "value": 360502
        }, {
            "text": "分宜县",
            "value": 360521
        }]
    }, {
        "text": "鹰潭市",
        "value": 360600,
        "children": [{
            "text": "月湖区",
            "value": 360602
        }, {
            "text": "余江区",
            "value": 360603
        }, {
            "text": "贵溪市",
            "value": 360681
        }]
    }, {
        "text": "赣州市",
        "value": 360700,
        "children": [{
            "text": "章贡区",
            "value": 360702
        }, {
            "text": "南康区",
            "value": 360703
        }, {
            "text": "赣县区",
            "value": 360704
        }, {
            "text": "信丰县",
            "value": 360722
        }, {
            "text": "大余县",
            "value": 360723
        }, {
            "text": "上犹县",
            "value": 360724
        }, {
            "text": "崇义县",
            "value": 360725
        }, {
            "text": "安远县",
            "value": 360726
        }, {
            "text": "龙南县",
            "value": 360727
        }, {
            "text": "定南县",
            "value": 360728
        }, {
            "text": "全南县",
            "value": 360729
        }, {
            "text": "宁都县",
            "value": 360730
        }, {
            "text": "于都县",
            "value": 360731
        }, {
            "text": "兴国县",
            "value": 360732
        }, {
            "text": "会昌县",
            "value": 360733
        }, {
            "text": "寻乌县",
            "value": 360734
        }, {
            "text": "石城县",
            "value": 360735
        }, {
            "text": "瑞金市",
            "value": 360781
        }]
    }, {
        "text": "吉安市",
        "value": 360800,
        "children": [{
            "text": "吉州区",
            "value": 360802
        }, {
            "text": "青原区",
            "value": 360803
        }, {
            "text": "吉安县",
            "value": 360821
        }, {
            "text": "吉水县",
            "value": 360822
        }, {
            "text": "峡江县",
            "value": 360823
        }, {
            "text": "新干县",
            "value": 360824
        }, {
            "text": "永丰县",
            "value": 360825
        }, {
            "text": "泰和县",
            "value": 360826
        }, {
            "text": "遂川县",
            "value": 360827
        }, {
            "text": "万安县",
            "value": 360828
        }, {
            "text": "安福县",
            "value": 360829
        }, {
            "text": "永新县",
            "value": 360830
        }, {
            "text": "井冈山市",
            "value": 360881
        }]
    }, {
        "text": "宜春市",
        "value": 360900,
        "children": [{
            "text": "袁州区",
            "value": 360902
        }, {
            "text": "奉新县",
            "value": 360921
        }, {
            "text": "万载县",
            "value": 360922
        }, {
            "text": "上高县",
            "value": 360923
        }, {
            "text": "宜丰县",
            "value": 360924
        }, {
            "text": "靖安县",
            "value": 360925
        }, {
            "text": "铜鼓县",
            "value": 360926
        }, {
            "text": "丰城市",
            "value": 360981
        }, {
            "text": "樟树市",
            "value": 360982
        }, {
            "text": "高安市",
            "value": 360983
        }]
    }, {
        "text": "抚州市",
        "value": 361000,
        "children": [{
            "text": "临川区",
            "value": 361002
        }, {
            "text": "东乡区",
            "value": 361003
        }, {
            "text": "南城县",
            "value": 361021
        }, {
            "text": "黎川县",
            "value": 361022
        }, {
            "text": "南丰县",
            "value": 361023
        }, {
            "text": "崇仁县",
            "value": 361024
        }, {
            "text": "乐安县",
            "value": 361025
        }, {
            "text": "宜黄县",
            "value": 361026
        }, {
            "text": "金溪县",
            "value": 361027
        }, {
            "text": "资溪县",
            "value": 361028
        }, {
            "text": "广昌县",
            "value": 361030
        }]
    }, {
        "text": "上饶市",
        "value": 361100,
        "children": [{
            "text": "信州区",
            "value": 361102
        }, {
            "text": "广丰区",
            "value": 361103
        }, {
            "text": "广信区",
            "value": 361104
        }, {
            "text": "玉山县",
            "value": 361123
        }, {
            "text": "铅山县",
            "value": 361124
        }, {
            "text": "横峰县",
            "value": 361125
        }, {
            "text": "弋阳县",
            "value": 361126
        }, {
            "text": "余干县",
            "value": 361127
        }, {
            "text": "鄱阳县",
            "value": 361128
        }, {
            "text": "万年县",
            "value": 361129
        }, {
            "text": "婺源县",
            "value": 361130
        }, {
            "text": "德兴市",
            "value": 361181
        }]
    }]
}, {
    "text": "山东省",
    "value": 370000,
    "children": [{
        "text": "济南市",
        "value": 370100,
        "children": [{
            "text": "历下区",
            "value": 370102
        }, {
            "text": "市中区",
            "value": 370103
        }, {
            "text": "槐荫区",
            "value": 370104
        }, {
            "text": "天桥区",
            "value": 370105
        }, {
            "text": "历城区",
            "value": 370112
        }, {
            "text": "长清区",
            "value": 370113
        }, {
            "text": "章丘区",
            "value": 370114
        }, {
            "text": "济阳区",
            "value": 370115
        }, {
            "text": "莱芜区",
            "value": 370116
        }, {
            "text": "钢城区",
            "value": 370117
        }, {
            "text": "平阴县",
            "value": 370124
        }, {
            "text": "商河县",
            "value": 370126
        }]
    }, {
        "text": "青岛市",
        "value": 370200,
        "children": [{
            "text": "市南区",
            "value": 370202
        }, {
            "text": "市北区",
            "value": 370203
        }, {
            "text": "黄岛区",
            "value": 370211
        }, {
            "text": "崂山区",
            "value": 370212
        }, {
            "text": "李沧区",
            "value": 370213
        }, {
            "text": "城阳区",
            "value": 370214
        }, {
            "text": "即墨区",
            "value": 370215
        }, {
            "text": "胶州市",
            "value": 370281
        }, {
            "text": "平度市",
            "value": 370283
        }, {
            "text": "莱西市",
            "value": 370285
        }]
    }, {
        "text": "淄博市",
        "value": 370300,
        "children": [{
            "text": "淄川区",
            "value": 370302
        }, {
            "text": "张店区",
            "value": 370303
        }, {
            "text": "博山区",
            "value": 370304
        }, {
            "text": "临淄区",
            "value": 370305
        }, {
            "text": "周村区",
            "value": 370306
        }, {
            "text": "桓台县",
            "value": 370321
        }, {
            "text": "高青县",
            "value": 370322
        }, {
            "text": "沂源县",
            "value": 370323
        }]
    }, {
        "text": "枣庄市",
        "value": 370400,
        "children": [{
            "text": "市中区",
            "value": 370402
        }, {
            "text": "薛城区",
            "value": 370403
        }, {
            "text": "峄城区",
            "value": 370404
        }, {
            "text": "台儿庄区",
            "value": 370405
        }, {
            "text": "山亭区",
            "value": 370406
        }, {
            "text": "滕州市",
            "value": 370481
        }]
    }, {
        "text": "东营市",
        "value": 370500,
        "children": [{
            "text": "东营区",
            "value": 370502
        }, {
            "text": "河口区",
            "value": 370503
        }, {
            "text": "垦利区",
            "value": 370505
        }, {
            "text": "利津县",
            "value": 370522
        }, {
            "text": "广饶县",
            "value": 370523
        }]
    }, {
        "text": "烟台市",
        "value": 370600,
        "children": [{
            "text": "芝罘区",
            "value": 370602
        }, {
            "text": "福山区",
            "value": 370611
        }, {
            "text": "牟平区",
            "value": 370612
        }, {
            "text": "莱山区",
            "value": 370613
        }, {
            "text": "长岛县",
            "value": 370634
        }, {
            "text": "龙口市",
            "value": 370681
        }, {
            "text": "莱阳市",
            "value": 370682
        }, {
            "text": "莱州市",
            "value": 370683
        }, {
            "text": "蓬莱市",
            "value": 370684
        }, {
            "text": "招远市",
            "value": 370685
        }, {
            "text": "栖霞市",
            "value": 370686
        }, {
            "text": "海阳市",
            "value": 370687
        }]
    }, {
        "text": "潍坊市",
        "value": 370700,
        "children": [{
            "text": "潍城区",
            "value": 370702
        }, {
            "text": "寒亭区",
            "value": 370703
        }, {
            "text": "坊子区",
            "value": 370704
        }, {
            "text": "奎文区",
            "value": 370705
        }, {
            "text": "临朐县",
            "value": 370724
        }, {
            "text": "昌乐县",
            "value": 370725
        }, {
            "text": "青州市",
            "value": 370781
        }, {
            "text": "诸城市",
            "value": 370782
        }, {
            "text": "寿光市",
            "value": 370783
        }, {
            "text": "安丘市",
            "value": 370784
        }, {
            "text": "高密市",
            "value": 370785
        }, {
            "text": "昌邑市",
            "value": 370786
        }]
    }, {
        "text": "济宁市",
        "value": 370800,
        "children": [{
            "text": "任城区",
            "value": 370811
        }, {
            "text": "兖州区",
            "value": 370812
        }, {
            "text": "微山县",
            "value": 370826
        }, {
            "text": "鱼台县",
            "value": 370827
        }, {
            "text": "金乡县",
            "value": 370828
        }, {
            "text": "嘉祥县",
            "value": 370829
        }, {
            "text": "汶上县",
            "value": 370830
        }, {
            "text": "泗水县",
            "value": 370831
        }, {
            "text": "梁山县",
            "value": 370832
        }, {
            "text": "曲阜市",
            "value": 370881
        }, {
            "text": "邹城市",
            "value": 370883
        }]
    }, {
        "text": "泰安市",
        "value": 370900,
        "children": [{
            "text": "泰山区",
            "value": 370902
        }, {
            "text": "岱岳区",
            "value": 370911
        }, {
            "text": "宁阳县",
            "value": 370921
        }, {
            "text": "东平县",
            "value": 370923
        }, {
            "text": "新泰市",
            "value": 370982
        }, {
            "text": "肥城市",
            "value": 370983
        }]
    }, {
        "text": "威海市",
        "value": 371000,
        "children": [{
            "text": "环翠区",
            "value": 371002
        }, {
            "text": "文登区",
            "value": 371003
        }, {
            "text": "荣成市",
            "value": 371082
        }, {
            "text": "乳山市",
            "value": 371083
        }]
    }, {
        "text": "日照市",
        "value": 371100,
        "children": [{
            "text": "东港区",
            "value": 371102
        }, {
            "text": "岚山区",
            "value": 371103
        }, {
            "text": "五莲县",
            "value": 371121
        }, {
            "text": "莒县",
            "value": 371122
        }]
    }, {
        "text": "临沂市",
        "value": 371300,
        "children": [{
            "text": "兰山区",
            "value": 371302
        }, {
            "text": "罗庄区",
            "value": 371311
        }, {
            "text": "河东区",
            "value": 371312
        }, {
            "text": "沂南县",
            "value": 371321
        }, {
            "text": "郯城县",
            "value": 371322
        }, {
            "text": "沂水县",
            "value": 371323
        }, {
            "text": "兰陵县",
            "value": 371324
        }, {
            "text": "费县",
            "value": 371325
        }, {
            "text": "平邑县",
            "value": 371326
        }, {
            "text": "莒南县",
            "value": 371327
        }, {
            "text": "蒙阴县",
            "value": 371328
        }, {
            "text": "临沭县",
            "value": 371329
        }]
    }, {
        "text": "德州市",
        "value": 371400,
        "children": [{
            "text": "德城区",
            "value": 371402
        }, {
            "text": "陵城区",
            "value": 371403
        }, {
            "text": "宁津县",
            "value": 371422
        }, {
            "text": "庆云县",
            "value": 371423
        }, {
            "text": "临邑县",
            "value": 371424
        }, {
            "text": "齐河县",
            "value": 371425
        }, {
            "text": "平原县",
            "value": 371426
        }, {
            "text": "夏津县",
            "value": 371427
        }, {
            "text": "武城县",
            "value": 371428
        }, {
            "text": "乐陵市",
            "value": 371481
        }, {
            "text": "禹城市",
            "value": 371482
        }]
    }, {
        "text": "聊城市",
        "value": 371500,
        "children": [{
            "text": "东昌府区",
            "value": 371502
        }, {
            "text": "茌平区",
            "value": 371503
        }, {
            "text": "阳谷县",
            "value": 371521
        }, {
            "text": "莘县",
            "value": 371522
        }, {
            "text": "东阿县",
            "value": 371524
        }, {
            "text": "冠县",
            "value": 371525
        }, {
            "text": "高唐县",
            "value": 371526
        }, {
            "text": "临清市",
            "value": 371581
        }]
    }, {
        "text": "滨州市",
        "value": 371600,
        "children": [{
            "text": "滨城区",
            "value": 371602
        }, {
            "text": "沾化区",
            "value": 371603
        }, {
            "text": "惠民县",
            "value": 371621
        }, {
            "text": "阳信县",
            "value": 371622
        }, {
            "text": "无棣县",
            "value": 371623
        }, {
            "text": "博兴县",
            "value": 371625
        }, {
            "text": "邹平市",
            "value": 371681
        }]
    }, {
        "text": "菏泽市",
        "value": 371700,
        "children": [{
            "text": "牡丹区",
            "value": 371702
        }, {
            "text": "定陶区",
            "value": 371703
        }, {
            "text": "曹县",
            "value": 371721
        }, {
            "text": "单县",
            "value": 371722
        }, {
            "text": "成武县",
            "value": 371723
        }, {
            "text": "巨野县",
            "value": 371724
        }, {
            "text": "郓城县",
            "value": 371725
        }, {
            "text": "鄄城县",
            "value": 371726
        }, {
            "text": "东明县",
            "value": 371728
        }]
    }]
}, {
    "text": "河南省",
    "value": 410000,
    "children": [{
        "text": "郑州市",
        "value": 410100,
        "children": [{
            "text": "中原区",
            "value": 410102
        }, {
            "text": "二七区",
            "value": 410103
        }, {
            "text": "管城回族区",
            "value": 410104
        }, {
            "text": "金水区",
            "value": 410105
        }, {
            "text": "上街区",
            "value": 410106
        }, {
            "text": "惠济区",
            "value": 410108
        }, {
            "text": "中牟县",
            "value": 410122
        }, {
            "text": "巩义市",
            "value": 410181
        }, {
            "text": "荥阳市",
            "value": 410182
        }, {
            "text": "新密市",
            "value": 410183
        }, {
            "text": "新郑市",
            "value": 410184
        }, {
            "text": "登封市",
            "value": 410185
        }]
    }, {
        "text": "开封市",
        "value": 410200,
        "children": [{
            "text": "龙亭区",
            "value": 410202
        }, {
            "text": "顺河回族区",
            "value": 410203
        }, {
            "text": "鼓楼区",
            "value": 410204
        }, {
            "text": "禹王台区",
            "value": 410205
        }, {
            "text": "祥符区",
            "value": 410212
        }, {
            "text": "杞县",
            "value": 410221
        }, {
            "text": "通许县",
            "value": 410222
        }, {
            "text": "尉氏县",
            "value": 410223
        }, {
            "text": "兰考县",
            "value": 410225
        }]
    }, {
        "text": "洛阳市",
        "value": 410300,
        "children": [{
            "text": "老城区",
            "value": 410302
        }, {
            "text": "西工区",
            "value": 410303
        }, {
            "text": "瀍河回族区",
            "value": 410304
        }, {
            "text": "涧西区",
            "value": 410305
        }, {
            "text": "吉利区",
            "value": 410306
        }, {
            "text": "洛龙区",
            "value": 410311
        }, {
            "text": "孟津县",
            "value": 410322
        }, {
            "text": "新安县",
            "value": 410323
        }, {
            "text": "栾川县",
            "value": 410324
        }, {
            "text": "嵩县",
            "value": 410325
        }, {
            "text": "汝阳县",
            "value": 410326
        }, {
            "text": "宜阳县",
            "value": 410327
        }, {
            "text": "洛宁县",
            "value": 410328
        }, {
            "text": "伊川县",
            "value": 410329
        }, {
            "text": "偃师市",
            "value": 410381
        }]
    }, {
        "text": "平顶山市",
        "value": 410400,
        "children": [{
            "text": "新华区",
            "value": 410402
        }, {
            "text": "卫东区",
            "value": 410403
        }, {
            "text": "石龙区",
            "value": 410404
        }, {
            "text": "湛河区",
            "value": 410411
        }, {
            "text": "宝丰县",
            "value": 410421
        }, {
            "text": "叶县",
            "value": 410422
        }, {
            "text": "鲁山县",
            "value": 410423
        }, {
            "text": "郏县",
            "value": 410425
        }, {
            "text": "舞钢市",
            "value": 410481
        }, {
            "text": "汝州市",
            "value": 410482
        }]
    }, {
        "text": "安阳市",
        "value": 410500,
        "children": [{
            "text": "文峰区",
            "value": 410502
        }, {
            "text": "北关区",
            "value": 410503
        }, {
            "text": "殷都区",
            "value": 410505
        }, {
            "text": "龙安区",
            "value": 410506
        }, {
            "text": "安阳县",
            "value": 410522
        }, {
            "text": "汤阴县",
            "value": 410523
        }, {
            "text": "滑县",
            "value": 410526
        }, {
            "text": "内黄县",
            "value": 410527
        }, {
            "text": "林州市",
            "value": 410581
        }]
    }, {
        "text": "鹤壁市",
        "value": 410600,
        "children": [{
            "text": "鹤山区",
            "value": 410602
        }, {
            "text": "山城区",
            "value": 410603
        }, {
            "text": "淇滨区",
            "value": 410611
        }, {
            "text": "浚县",
            "value": 410621
        }, {
            "text": "淇县",
            "value": 410622
        }]
    }, {
        "text": "新乡市",
        "value": 410700,
        "children": [{
            "text": "红旗区",
            "value": 410702
        }, {
            "text": "卫滨区",
            "value": 410703
        }, {
            "text": "凤泉区",
            "value": 410704
        }, {
            "text": "牧野区",
            "value": 410711
        }, {
            "text": "新乡县",
            "value": 410721
        }, {
            "text": "获嘉县",
            "value": 410724
        }, {
            "text": "原阳县",
            "value": 410725
        }, {
            "text": "延津县",
            "value": 410726
        }, {
            "text": "封丘县",
            "value": 410727
        }, {
            "text": "卫辉市",
            "value": 410781
        }, {
            "text": "辉县市",
            "value": 410782
        }, {
            "text": "长垣市",
            "value": 410783
        }]
    }, {
        "text": "焦作市",
        "value": 410800,
        "children": [{
            "text": "解放区",
            "value": 410802
        }, {
            "text": "中站区",
            "value": 410803
        }, {
            "text": "马村区",
            "value": 410804
        }, {
            "text": "山阳区",
            "value": 410811
        }, {
            "text": "修武县",
            "value": 410821
        }, {
            "text": "博爱县",
            "value": 410822
        }, {
            "text": "武陟县",
            "value": 410823
        }, {
            "text": "温县",
            "value": 410825
        }, {
            "text": "沁阳市",
            "value": 410882
        }, {
            "text": "孟州市",
            "value": 410883
        }]
    }, {
        "text": "濮阳市",
        "value": 410900,
        "children": [{
            "text": "华龙区",
            "value": 410902
        }, {
            "text": "清丰县",
            "value": 410922
        }, {
            "text": "南乐县",
            "value": 410923
        }, {
            "text": "范县",
            "value": 410926
        }, {
            "text": "台前县",
            "value": 410927
        }, {
            "text": "濮阳县",
            "value": 410928
        }]
    }, {
        "text": "许昌市",
        "value": 411000,
        "children": [{
            "text": "魏都区",
            "value": 411002
        }, {
            "text": "建安区",
            "value": 411003
        }, {
            "text": "鄢陵县",
            "value": 411024
        }, {
            "text": "襄城县",
            "value": 411025
        }, {
            "text": "禹州市",
            "value": 411081
        }, {
            "text": "长葛市",
            "value": 411082
        }]
    }, {
        "text": "漯河市",
        "value": 411100,
        "children": [{
            "text": "源汇区",
            "value": 411102
        }, {
            "text": "郾城区",
            "value": 411103
        }, {
            "text": "召陵区",
            "value": 411104
        }, {
            "text": "舞阳县",
            "value": 411121
        }, {
            "text": "临颍县",
            "value": 411122
        }]
    }, {
        "text": "三门峡市",
        "value": 411200,
        "children": [{
            "text": "湖滨区",
            "value": 411202
        }, {
            "text": "陕州区",
            "value": 411203
        }, {
            "text": "渑池县",
            "value": 411221
        }, {
            "text": "卢氏县",
            "value": 411224
        }, {
            "text": "义马市",
            "value": 411281
        }, {
            "text": "灵宝市",
            "value": 411282
        }]
    }, {
        "text": "南阳市",
        "value": 411300,
        "children": [{
            "text": "宛城区",
            "value": 411302
        }, {
            "text": "卧龙区",
            "value": 411303
        }, {
            "text": "南召县",
            "value": 411321
        }, {
            "text": "方城县",
            "value": 411322
        }, {
            "text": "西峡县",
            "value": 411323
        }, {
            "text": "镇平县",
            "value": 411324
        }, {
            "text": "内乡县",
            "value": 411325
        }, {
            "text": "淅川县",
            "value": 411326
        }, {
            "text": "社旗县",
            "value": 411327
        }, {
            "text": "唐河县",
            "value": 411328
        }, {
            "text": "新野县",
            "value": 411329
        }, {
            "text": "桐柏县",
            "value": 411330
        }, {
            "text": "邓州市",
            "value": 411381
        }]
    }, {
        "text": "商丘市",
        "value": 411400,
        "children": [{
            "text": "梁园区",
            "value": 411402
        }, {
            "text": "睢阳区",
            "value": 411403
        }, {
            "text": "民权县",
            "value": 411421
        }, {
            "text": "睢县",
            "value": 411422
        }, {
            "text": "宁陵县",
            "value": 411423
        }, {
            "text": "柘城县",
            "value": 411424
        }, {
            "text": "虞城县",
            "value": 411425
        }, {
            "text": "夏邑县",
            "value": 411426
        }, {
            "text": "永城市",
            "value": 411481
        }]
    }, {
        "text": "信阳市",
        "value": 411500,
        "children": [{
            "text": "浉河区",
            "value": 411502
        }, {
            "text": "平桥区",
            "value": 411503
        }, {
            "text": "罗山县",
            "value": 411521
        }, {
            "text": "光山县",
            "value": 411522
        }, {
            "text": "新县",
            "value": 411523
        }, {
            "text": "商城县",
            "value": 411524
        }, {
            "text": "固始县",
            "value": 411525
        }, {
            "text": "潢川县",
            "value": 411526
        }, {
            "text": "淮滨县",
            "value": 411527
        }, {
            "text": "息县",
            "value": 411528
        }]
    }, {
        "text": "周口市",
        "value": 411600,
        "children": [{
            "text": "川汇区",
            "value": 411602
        }, {
            "text": "淮阳区",
            "value": 411603
        }, {
            "text": "扶沟县",
            "value": 411621
        }, {
            "text": "西华县",
            "value": 411622
        }, {
            "text": "商水县",
            "value": 411623
        }, {
            "text": "沈丘县",
            "value": 411624
        }, {
            "text": "郸城县",
            "value": 411625
        }, {
            "text": "太康县",
            "value": 411627
        }, {
            "text": "鹿邑县",
            "value": 411628
        }, {
            "text": "项城市",
            "value": 411681
        }]
    }, {
        "text": "驻马店市",
        "value": 411700,
        "children": [{
            "text": "驿城区",
            "value": 411702
        }, {
            "text": "西平县",
            "value": 411721
        }, {
            "text": "上蔡县",
            "value": 411722
        }, {
            "text": "平舆县",
            "value": 411723
        }, {
            "text": "正阳县",
            "value": 411724
        }, {
            "text": "确山县",
            "value": 411725
        }, {
            "text": "泌阳县",
            "value": 411726
        }, {
            "text": "汝南县",
            "value": 411727
        }, {
            "text": "遂平县",
            "value": 411728
        }, {
            "text": "新蔡县",
            "value": 411729
        }]
    }, {
        "text": "济源市",
        "value": 419001,
        "children": [{
            "text": "济源市",
            "value": 419001
        }]
    }]
}, {
    "text": "湖北省",
    "value": 420000,
    "children": [{
        "text": "武汉市",
        "value": 420100,
        "children": [{
            "text": "江岸区",
            "value": 420102
        }, {
            "text": "江汉区",
            "value": 420103
        }, {
            "text": "硚口区",
            "value": 420104
        }, {
            "text": "汉阳区",
            "value": 420105
        }, {
            "text": "武昌区",
            "value": 420106
        }, {
            "text": "青山区",
            "value": 420107
        }, {
            "text": "洪山区",
            "value": 420111
        }, {
            "text": "东西湖区",
            "value": 420112
        }, {
            "text": "汉南区",
            "value": 420113
        }, {
            "text": "蔡甸区",
            "value": 420114
        }, {
            "text": "江夏区",
            "value": 420115
        }, {
            "text": "黄陂区",
            "value": 420116
        }, {
            "text": "新洲区",
            "value": 420117
        }]
    }, {
        "text": "黄石市",
        "value": 420200,
        "children": [{
            "text": "黄石港区",
            "value": 420202
        }, {
            "text": "西塞山区",
            "value": 420203
        }, {
            "text": "下陆区",
            "value": 420204
        }, {
            "text": "铁山区",
            "value": 420205
        }, {
            "text": "阳新县",
            "value": 420222
        }, {
            "text": "大冶市",
            "value": 420281
        }]
    }, {
        "text": "十堰市",
        "value": 420300,
        "children": [{
            "text": "茅箭区",
            "value": 420302
        }, {
            "text": "张湾区",
            "value": 420303
        }, {
            "text": "郧阳区",
            "value": 420304
        }, {
            "text": "郧西县",
            "value": 420322
        }, {
            "text": "竹山县",
            "value": 420323
        }, {
            "text": "竹溪县",
            "value": 420324
        }, {
            "text": "房县",
            "value": 420325
        }, {
            "text": "丹江口市",
            "value": 420381
        }]
    }, {
        "text": "宜昌市",
        "value": 420500,
        "children": [{
            "text": "西陵区",
            "value": 420502
        }, {
            "text": "伍家岗区",
            "value": 420503
        }, {
            "text": "点军区",
            "value": 420504
        }, {
            "text": "猇亭区",
            "value": 420505
        }, {
            "text": "夷陵区",
            "value": 420506
        }, {
            "text": "远安县",
            "value": 420525
        }, {
            "text": "兴山县",
            "value": 420526
        }, {
            "text": "秭归县",
            "value": 420527
        }, {
            "text": "长阳土家族自治县",
            "value": 420528
        }, {
            "text": "五峰土家族自治县",
            "value": 420529
        }, {
            "text": "宜都市",
            "value": 420581
        }, {
            "text": "当阳市",
            "value": 420582
        }, {
            "text": "枝江市",
            "value": 420583
        }]
    }, {
        "text": "襄阳市",
        "value": 420600,
        "children": [{
            "text": "襄城区",
            "value": 420602
        }, {
            "text": "樊城区",
            "value": 420606
        }, {
            "text": "襄州区",
            "value": 420607
        }, {
            "text": "南漳县",
            "value": 420624
        }, {
            "text": "谷城县",
            "value": 420625
        }, {
            "text": "保康县",
            "value": 420626
        }, {
            "text": "老河口市",
            "value": 420682
        }, {
            "text": "枣阳市",
            "value": 420683
        }, {
            "text": "宜城市",
            "value": 420684
        }]
    }, {
        "text": "鄂州市",
        "value": 420700,
        "children": [{
            "text": "梁子湖区",
            "value": 420702
        }, {
            "text": "华容区",
            "value": 420703
        }, {
            "text": "鄂城区",
            "value": 420704
        }]
    }, {
        "text": "荆门市",
        "value": 420800,
        "children": [{
            "text": "东宝区",
            "value": 420802
        }, {
            "text": "掇刀区",
            "value": 420804
        }, {
            "text": "沙洋县",
            "value": 420822
        }, {
            "text": "钟祥市",
            "value": 420881
        }, {
            "text": "京山市",
            "value": 420882
        }]
    }, {
        "text": "孝感市",
        "value": 420900,
        "children": [{
            "text": "孝南区",
            "value": 420902
        }, {
            "text": "孝昌县",
            "value": 420921
        }, {
            "text": "大悟县",
            "value": 420922
        }, {
            "text": "云梦县",
            "value": 420923
        }, {
            "text": "应城市",
            "value": 420981
        }, {
            "text": "安陆市",
            "value": 420982
        }, {
            "text": "汉川市",
            "value": 420984
        }]
    }, {
        "text": "荆州市",
        "value": 421000,
        "children": [{
            "text": "沙市区",
            "value": 421002
        }, {
            "text": "荆州区",
            "value": 421003
        }, {
            "text": "公安县",
            "value": 421022
        }, {
            "text": "监利县",
            "value": 421023
        }, {
            "text": "江陵县",
            "value": 421024
        }, {
            "text": "石首市",
            "value": 421081
        }, {
            "text": "洪湖市",
            "value": 421083
        }, {
            "text": "松滋市",
            "value": 421087
        }]
    }, {
        "text": "黄冈市",
        "value": 421100,
        "children": [{
            "text": "黄州区",
            "value": 421102
        }, {
            "text": "团风县",
            "value": 421121
        }, {
            "text": "红安县",
            "value": 421122
        }, {
            "text": "罗田县",
            "value": 421123
        }, {
            "text": "英山县",
            "value": 421124
        }, {
            "text": "浠水县",
            "value": 421125
        }, {
            "text": "蕲春县",
            "value": 421126
        }, {
            "text": "黄梅县",
            "value": 421127
        }, {
            "text": "麻城市",
            "value": 421181
        }, {
            "text": "武穴市",
            "value": 421182
        }]
    }, {
        "text": "咸宁市",
        "value": 421200,
        "children": [{
            "text": "咸安区",
            "value": 421202
        }, {
            "text": "嘉鱼县",
            "value": 421221
        }, {
            "text": "通城县",
            "value": 421222
        }, {
            "text": "崇阳县",
            "value": 421223
        }, {
            "text": "通山县",
            "value": 421224
        }, {
            "text": "赤壁市",
            "value": 421281
        }]
    }, {
        "text": "随州市",
        "value": 421300,
        "children": [{
            "text": "曾都区",
            "value": 421303
        }, {
            "text": "随县",
            "value": 421321
        }, {
            "text": "广水市",
            "value": 421381
        }]
    }, {
        "text": "恩施土家族苗族自治州",
        "value": 422800,
        "children": [{
            "text": "恩施市",
            "value": 422801
        }, {
            "text": "利川市",
            "value": 422802
        }, {
            "text": "建始县",
            "value": 422822
        }, {
            "text": "巴东县",
            "value": 422823
        }, {
            "text": "宣恩县",
            "value": 422825
        }, {
            "text": "咸丰县",
            "value": 422826
        }, {
            "text": "来凤县",
            "value": 422827
        }, {
            "text": "鹤峰县",
            "value": 422828
        }]
    }, {
        "text": "仙桃市",
        "value": 429004,
        "children": [{
            "text": "仙桃市",
            "value": 429004
        }]
    }, {
        "text": "潜江市",
        "value": 429005,
        "children": [{
            "text": "潜江市",
            "value": 429005
        }]
    }, {
        "text": "天门市",
        "value": 429006,
        "children": [{
            "text": "天门市",
            "value": 429006
        }]
    }, {
        "text": "神农架林区",
        "value": 429021,
        "children": [{
            "text": "神农架林区",
            "value": 429021
        }]
    }]
}, {
    "text": "湖南省",
    "value": 430000,
    "children": [{
        "text": "长沙市",
        "value": 430100,
        "children": [{
            "text": "芙蓉区",
            "value": 430102
        }, {
            "text": "天心区",
            "value": 430103
        }, {
            "text": "岳麓区",
            "value": 430104
        }, {
            "text": "开福区",
            "value": 430105
        }, {
            "text": "雨花区",
            "value": 430111
        }, {
            "text": "望城区",
            "value": 430112
        }, {
            "text": "长沙县",
            "value": 430121
        }, {
            "text": "浏阳市",
            "value": 430181
        }, {
            "text": "宁乡市",
            "value": 430182
        }]
    }, {
        "text": "株洲市",
        "value": 430200,
        "children": [{
            "text": "荷塘区",
            "value": 430202
        }, {
            "text": "芦淞区",
            "value": 430203
        }, {
            "text": "石峰区",
            "value": 430204
        }, {
            "text": "天元区",
            "value": 430211
        }, {
            "text": "渌口区",
            "value": 430212
        }, {
            "text": "攸县",
            "value": 430223
        }, {
            "text": "茶陵县",
            "value": 430224
        }, {
            "text": "炎陵县",
            "value": 430225
        }, {
            "text": "醴陵市",
            "value": 430281
        }]
    }, {
        "text": "湘潭市",
        "value": 430300,
        "children": [{
            "text": "雨湖区",
            "value": 430302
        }, {
            "text": "岳塘区",
            "value": 430304
        }, {
            "text": "湘潭县",
            "value": 430321
        }, {
            "text": "湘乡市",
            "value": 430381
        }, {
            "text": "韶山市",
            "value": 430382
        }]
    }, {
        "text": "衡阳市",
        "value": 430400,
        "children": [{
            "text": "珠晖区",
            "value": 430405
        }, {
            "text": "雁峰区",
            "value": 430406
        }, {
            "text": "石鼓区",
            "value": 430407
        }, {
            "text": "蒸湘区",
            "value": 430408
        }, {
            "text": "南岳区",
            "value": 430412
        }, {
            "text": "衡阳县",
            "value": 430421
        }, {
            "text": "衡南县",
            "value": 430422
        }, {
            "text": "衡山县",
            "value": 430423
        }, {
            "text": "衡东县",
            "value": 430424
        }, {
            "text": "祁东县",
            "value": 430426
        }, {
            "text": "耒阳市",
            "value": 430481
        }, {
            "text": "常宁市",
            "value": 430482
        }]
    }, {
        "text": "邵阳市",
        "value": 430500,
        "children": [{
            "text": "双清区",
            "value": 430502
        }, {
            "text": "大祥区",
            "value": 430503
        }, {
            "text": "北塔区",
            "value": 430511
        }, {
            "text": "新邵县",
            "value": 430522
        }, {
            "text": "邵阳县",
            "value": 430523
        }, {
            "text": "隆回县",
            "value": 430524
        }, {
            "text": "洞口县",
            "value": 430525
        }, {
            "text": "绥宁县",
            "value": 430527
        }, {
            "text": "新宁县",
            "value": 430528
        }, {
            "text": "城步苗族自治县",
            "value": 430529
        }, {
            "text": "武冈市",
            "value": 430581
        }, {
            "text": "邵东市",
            "value": 430582
        }]
    }, {
        "text": "岳阳市",
        "value": 430600,
        "children": [{
            "text": "岳阳楼区",
            "value": 430602
        }, {
            "text": "云溪区",
            "value": 430603
        }, {
            "text": "君山区",
            "value": 430611
        }, {
            "text": "岳阳县",
            "value": 430621
        }, {
            "text": "华容县",
            "value": 430623
        }, {
            "text": "湘阴县",
            "value": 430624
        }, {
            "text": "平江县",
            "value": 430626
        }, {
            "text": "汨罗市",
            "value": 430681
        }, {
            "text": "临湘市",
            "value": 430682
        }]
    }, {
        "text": "常德市",
        "value": 430700,
        "children": [{
            "text": "武陵区",
            "value": 430702
        }, {
            "text": "鼎城区",
            "value": 430703
        }, {
            "text": "安乡县",
            "value": 430721
        }, {
            "text": "汉寿县",
            "value": 430722
        }, {
            "text": "澧县",
            "value": 430723
        }, {
            "text": "临澧县",
            "value": 430724
        }, {
            "text": "桃源县",
            "value": 430725
        }, {
            "text": "石门县",
            "value": 430726
        }, {
            "text": "津市市",
            "value": 430781
        }]
    }, {
        "text": "张家界市",
        "value": 430800,
        "children": [{
            "text": "永定区",
            "value": 430802
        }, {
            "text": "武陵源区",
            "value": 430811
        }, {
            "text": "慈利县",
            "value": 430821
        }, {
            "text": "桑植县",
            "value": 430822
        }]
    }, {
        "text": "益阳市",
        "value": 430900,
        "children": [{
            "text": "资阳区",
            "value": 430902
        }, {
            "text": "赫山区",
            "value": 430903
        }, {
            "text": "南县",
            "value": 430921
        }, {
            "text": "桃江县",
            "value": 430922
        }, {
            "text": "安化县",
            "value": 430923
        }, {
            "text": "沅江市",
            "value": 430981
        }]
    }, {
        "text": "郴州市",
        "value": 431000,
        "children": [{
            "text": "北湖区",
            "value": 431002
        }, {
            "text": "苏仙区",
            "value": 431003
        }, {
            "text": "桂阳县",
            "value": 431021
        }, {
            "text": "宜章县",
            "value": 431022
        }, {
            "text": "永兴县",
            "value": 431023
        }, {
            "text": "嘉禾县",
            "value": 431024
        }, {
            "text": "临武县",
            "value": 431025
        }, {
            "text": "汝城县",
            "value": 431026
        }, {
            "text": "桂东县",
            "value": 431027
        }, {
            "text": "安仁县",
            "value": 431028
        }, {
            "text": "资兴市",
            "value": 431081
        }]
    }, {
        "text": "永州市",
        "value": 431100,
        "children": [{
            "text": "零陵区",
            "value": 431102
        }, {
            "text": "冷水滩区",
            "value": 431103
        }, {
            "text": "祁阳县",
            "value": 431121
        }, {
            "text": "东安县",
            "value": 431122
        }, {
            "text": "双牌县",
            "value": 431123
        }, {
            "text": "道县",
            "value": 431124
        }, {
            "text": "江永县",
            "value": 431125
        }, {
            "text": "宁远县",
            "value": 431126
        }, {
            "text": "蓝山县",
            "value": 431127
        }, {
            "text": "新田县",
            "value": 431128
        }, {
            "text": "江华瑶族自治县",
            "value": 431129
        }]
    }, {
        "text": "怀化市",
        "value": 431200,
        "children": [{
            "text": "鹤城区",
            "value": 431202
        }, {
            "text": "中方县",
            "value": 431221
        }, {
            "text": "沅陵县",
            "value": 431222
        }, {
            "text": "辰溪县",
            "value": 431223
        }, {
            "text": "溆浦县",
            "value": 431224
        }, {
            "text": "会同县",
            "value": 431225
        }, {
            "text": "麻阳苗族自治县",
            "value": 431226
        }, {
            "text": "新晃侗族自治县",
            "value": 431227
        }, {
            "text": "芷江侗族自治县",
            "value": 431228
        }, {
            "text": "靖州苗族侗族自治县",
            "value": 431229
        }, {
            "text": "通道侗族自治县",
            "value": 431230
        }, {
            "text": "洪江市",
            "value": 431281
        }]
    }, {
        "text": "娄底市",
        "value": 431300,
        "children": [{
            "text": "娄星区",
            "value": 431302
        }, {
            "text": "双峰县",
            "value": 431321
        }, {
            "text": "新化县",
            "value": 431322
        }, {
            "text": "冷水江市",
            "value": 431381
        }, {
            "text": "涟源市",
            "value": 431382
        }]
    }, {
        "text": "湘西土家族苗族自治州",
        "value": 433100,
        "children": [{
            "text": "吉首市",
            "value": 433101
        }, {
            "text": "泸溪县",
            "value": 433122
        }, {
            "text": "凤凰县",
            "value": 433123
        }, {
            "text": "花垣县",
            "value": 433124
        }, {
            "text": "保靖县",
            "value": 433125
        }, {
            "text": "古丈县",
            "value": 433126
        }, {
            "text": "永顺县",
            "value": 433127
        }, {
            "text": "龙山县",
            "value": 433130
        }]
    }]
}, {
    "text": "广东省",
    "value": 440000,
    "children": [{
        "text": "广州市",
        "value": 440100,
        "children": [{
            "text": "荔湾区",
            "value": 440103
        }, {
            "text": "越秀区",
            "value": 440104
        }, {
            "text": "海珠区",
            "value": 440105
        }, {
            "text": "天河区",
            "value": 440106
        }, {
            "text": "白云区",
            "value": 440111
        }, {
            "text": "黄埔区",
            "value": 440112
        }, {
            "text": "番禺区",
            "value": 440113
        }, {
            "text": "花都区",
            "value": 440114
        }, {
            "text": "南沙区",
            "value": 440115
        }, {
            "text": "从化区",
            "value": 440117
        }, {
            "text": "增城区",
            "value": 440118
        }]
    }, {
        "text": "韶关市",
        "value": 440200,
        "children": [{
            "text": "武江区",
            "value": 440203
        }, {
            "text": "浈江区",
            "value": 440204
        }, {
            "text": "曲江区",
            "value": 440205
        }, {
            "text": "始兴县",
            "value": 440222
        }, {
            "text": "仁化县",
            "value": 440224
        }, {
            "text": "翁源县",
            "value": 440229
        }, {
            "text": "乳源瑶族自治县",
            "value": 440232
        }, {
            "text": "新丰县",
            "value": 440233
        }, {
            "text": "乐昌市",
            "value": 440281
        }, {
            "text": "南雄市",
            "value": 440282
        }]
    }, {
        "text": "深圳市",
        "value": 440300,
        "children": [{
            "text": "罗湖区",
            "value": 440303
        }, {
            "text": "福田区",
            "value": 440304
        }, {
            "text": "南山区",
            "value": 440305
        }, {
            "text": "宝安区",
            "value": 440306
        }, {
            "text": "龙岗区",
            "value": 440307
        }, {
            "text": "盐田区",
            "value": 440308
        }, {
            "text": "龙华区",
            "value": 440309
        }, {
            "text": "坪山区",
            "value": 440310
        }, {
            "text": "光明区",
            "value": 440311
        }]
    }, {
        "text": "珠海市",
        "value": 440400,
        "children": [{
            "text": "香洲区",
            "value": 440402
        }, {
            "text": "斗门区",
            "value": 440403
        }, {
            "text": "金湾区",
            "value": 440404
        }, {
            "text": "澳门大学横琴校区（由澳门实施管辖）",
            "value": 440499
        }]
    }, {
        "text": "汕头市",
        "value": 440500,
        "children": [{
            "text": "龙湖区",
            "value": 440507
        }, {
            "text": "金平区",
            "value": 440511
        }, {
            "text": "濠江区",
            "value": 440512
        }, {
            "text": "潮阳区",
            "value": 440513
        }, {
            "text": "潮南区",
            "value": 440514
        }, {
            "text": "澄海区",
            "value": 440515
        }, {
            "text": "南澳县",
            "value": 440523
        }]
    }, {
        "text": "佛山市",
        "value": 440600,
        "children": [{
            "text": "禅城区",
            "value": 440604
        }, {
            "text": "南海区",
            "value": 440605
        }, {
            "text": "顺德区",
            "value": 440606
        }, {
            "text": "三水区",
            "value": 440607
        }, {
            "text": "高明区",
            "value": 440608
        }]
    }, {
        "text": "江门市",
        "value": 440700,
        "children": [{
            "text": "蓬江区",
            "value": 440703
        }, {
            "text": "江海区",
            "value": 440704
        }, {
            "text": "新会区",
            "value": 440705
        }, {
            "text": "台山市",
            "value": 440781
        }, {
            "text": "开平市",
            "value": 440783
        }, {
            "text": "鹤山市",
            "value": 440784
        }, {
            "text": "恩平市",
            "value": 440785
        }]
    }, {
        "text": "湛江市",
        "value": 440800,
        "children": [{
            "text": "赤坎区",
            "value": 440802
        }, {
            "text": "霞山区",
            "value": 440803
        }, {
            "text": "坡头区",
            "value": 440804
        }, {
            "text": "麻章区",
            "value": 440811
        }, {
            "text": "遂溪县",
            "value": 440823
        }, {
            "text": "徐闻县",
            "value": 440825
        }, {
            "text": "廉江市",
            "value": 440881
        }, {
            "text": "雷州市",
            "value": 440882
        }, {
            "text": "吴川市",
            "value": 440883
        }]
    }, {
        "text": "茂名市",
        "value": 440900,
        "children": [{
            "text": "茂南区",
            "value": 440902
        }, {
            "text": "电白区",
            "value": 440904
        }, {
            "text": "高州市",
            "value": 440981
        }, {
            "text": "化州市",
            "value": 440982
        }, {
            "text": "信宜市",
            "value": 440983
        }]
    }, {
        "text": "肇庆市",
        "value": 441200,
        "children": [{
            "text": "端州区",
            "value": 441202
        }, {
            "text": "鼎湖区",
            "value": 441203
        }, {
            "text": "高要区",
            "value": 441204
        }, {
            "text": "广宁县",
            "value": 441223
        }, {
            "text": "怀集县",
            "value": 441224
        }, {
            "text": "封开县",
            "value": 441225
        }, {
            "text": "德庆县",
            "value": 441226
        }, {
            "text": "四会市",
            "value": 441284
        }]
    }, {
        "text": "惠州市",
        "value": 441300,
        "children": [{
            "text": "惠城区",
            "value": 441302
        }, {
            "text": "惠阳区",
            "value": 441303
        }, {
            "text": "博罗县",
            "value": 441322
        }, {
            "text": "惠东县",
            "value": 441323
        }, {
            "text": "龙门县",
            "value": 441324
        }]
    }, {
        "text": "梅州市",
        "value": 441400,
        "children": [{
            "text": "梅江区",
            "value": 441402
        }, {
            "text": "梅县区",
            "value": 441403
        }, {
            "text": "大埔县",
            "value": 441422
        }, {
            "text": "丰顺县",
            "value": 441423
        }, {
            "text": "五华县",
            "value": 441424
        }, {
            "text": "平远县",
            "value": 441426
        }, {
            "text": "蕉岭县",
            "value": 441427
        }, {
            "text": "兴宁市",
            "value": 441481
        }]
    }, {
        "text": "汕尾市",
        "value": 441500,
        "children": [{
            "text": "城区",
            "value": 441502
        }, {
            "text": "海丰县",
            "value": 441521
        }, {
            "text": "陆河县",
            "value": 441523
        }, {
            "text": "陆丰市",
            "value": 441581
        }]
    }, {
        "text": "河源市",
        "value": 441600,
        "children": [{
            "text": "源城区",
            "value": 441602
        }, {
            "text": "紫金县",
            "value": 441621
        }, {
            "text": "龙川县",
            "value": 441622
        }, {
            "text": "连平县",
            "value": 441623
        }, {
            "text": "和平县",
            "value": 441624
        }, {
            "text": "东源县",
            "value": 441625
        }]
    }, {
        "text": "阳江市",
        "value": 441700,
        "children": [{
            "text": "江城区",
            "value": 441702
        }, {
            "text": "阳东区",
            "value": 441704
        }, {
            "text": "阳西县",
            "value": 441721
        }, {
            "text": "阳春市",
            "value": 441781
        }]
    }, {
        "text": "清远市",
        "value": 441800,
        "children": [{
            "text": "清城区",
            "value": 441802
        }, {
            "text": "清新区",
            "value": 441803
        }, {
            "text": "佛冈县",
            "value": 441821
        }, {
            "text": "阳山县",
            "value": 441823
        }, {
            "text": "连山壮族瑶族自治县",
            "value": 441825
        }, {
            "text": "连南瑶族自治县",
            "value": 441826
        }, {
            "text": "英德市",
            "value": 441881
        }, {
            "text": "连州市",
            "value": 441882
        }]
    }, {
        "text": "东莞市",
        "value": 441900,
        "children": [{
            "text": "东莞市",
            "value": 441900
        }]
    }, {
        "text": "中山市",
        "value": 442000,
        "children": [{
            "text": "中山市",
            "value": 442000
        }]
    }, {
        "text": "东沙群岛",
        "value": 442100,
        "children": [{
            "text": "东沙群岛",
            "value": 442101
        }]
    }, {
        "text": "潮州市",
        "value": 445100,
        "children": [{
            "text": "湘桥区",
            "value": 445102
        }, {
            "text": "潮安区",
            "value": 445103
        }, {
            "text": "饶平县",
            "value": 445122
        }]
    }, {
        "text": "揭阳市",
        "value": 445200,
        "children": [{
            "text": "榕城区",
            "value": 445202
        }, {
            "text": "揭东区",
            "value": 445203
        }, {
            "text": "揭西县",
            "value": 445222
        }, {
            "text": "惠来县",
            "value": 445224
        }, {
            "text": "普宁市",
            "value": 445281
        }]
    }, {
        "text": "云浮市",
        "value": 445300,
        "children": [{
            "text": "云城区",
            "value": 445302
        }, {
            "text": "云安区",
            "value": 445303
        }, {
            "text": "新兴县",
            "value": 445321
        }, {
            "text": "郁南县",
            "value": 445322
        }, {
            "text": "罗定市",
            "value": 445381
        }]
    }]
}, {
    "text": "广西壮族自治区",
    "value": 450000,
    "children": [{
        "text": "南宁市",
        "value": 450100,
        "children": [{
            "text": "兴宁区",
            "value": 450102
        }, {
            "text": "青秀区",
            "value": 450103
        }, {
            "text": "江南区",
            "value": 450105
        }, {
            "text": "西乡塘区",
            "value": 450107
        }, {
            "text": "良庆区",
            "value": 450108
        }, {
            "text": "邕宁区",
            "value": 450109
        }, {
            "text": "武鸣区",
            "value": 450110
        }, {
            "text": "隆安县",
            "value": 450123
        }, {
            "text": "马山县",
            "value": 450124
        }, {
            "text": "上林县",
            "value": 450125
        }, {
            "text": "宾阳县",
            "value": 450126
        }, {
            "text": "横县",
            "value": 450127
        }]
    }, {
        "text": "柳州市",
        "value": 450200,
        "children": [{
            "text": "城中区",
            "value": 450202
        }, {
            "text": "鱼峰区",
            "value": 450203
        }, {
            "text": "柳南区",
            "value": 450204
        }, {
            "text": "柳北区",
            "value": 450205
        }, {
            "text": "柳江区",
            "value": 450206
        }, {
            "text": "柳城县",
            "value": 450222
        }, {
            "text": "鹿寨县",
            "value": 450223
        }, {
            "text": "融安县",
            "value": 450224
        }, {
            "text": "融水苗族自治县",
            "value": 450225
        }, {
            "text": "三江侗族自治县",
            "value": 450226
        }]
    }, {
        "text": "桂林市",
        "value": 450300,
        "children": [{
            "text": "秀峰区",
            "value": 450302
        }, {
            "text": "叠彩区",
            "value": 450303
        }, {
            "text": "象山区",
            "value": 450304
        }, {
            "text": "七星区",
            "value": 450305
        }, {
            "text": "雁山区",
            "value": 450311
        }, {
            "text": "临桂区",
            "value": 450312
        }, {
            "text": "阳朔县",
            "value": 450321
        }, {
            "text": "灵川县",
            "value": 450323
        }, {
            "text": "全州县",
            "value": 450324
        }, {
            "text": "兴安县",
            "value": 450325
        }, {
            "text": "永福县",
            "value": 450326
        }, {
            "text": "灌阳县",
            "value": 450327
        }, {
            "text": "龙胜各族自治县",
            "value": 450328
        }, {
            "text": "资源县",
            "value": 450329
        }, {
            "text": "平乐县",
            "value": 450330
        }, {
            "text": "恭城瑶族自治县",
            "value": 450332
        }, {
            "text": "荔浦市",
            "value": 450381
        }]
    }, {
        "text": "梧州市",
        "value": 450400,
        "children": [{
            "text": "万秀区",
            "value": 450403
        }, {
            "text": "长洲区",
            "value": 450405
        }, {
            "text": "龙圩区",
            "value": 450406
        }, {
            "text": "苍梧县",
            "value": 450421
        }, {
            "text": "藤县",
            "value": 450422
        }, {
            "text": "蒙山县",
            "value": 450423
        }, {
            "text": "岑溪市",
            "value": 450481
        }]
    }, {
        "text": "北海市",
        "value": 450500,
        "children": [{
            "text": "海城区",
            "value": 450502
        }, {
            "text": "银海区",
            "value": 450503
        }, {
            "text": "铁山港区",
            "value": 450512
        }, {
            "text": "合浦县",
            "value": 450521
        }]
    }, {
        "text": "防城港市",
        "value": 450600,
        "children": [{
            "text": "港口区",
            "value": 450602
        }, {
            "text": "防城区",
            "value": 450603
        }, {
            "text": "上思县",
            "value": 450621
        }, {
            "text": "东兴市",
            "value": 450681
        }]
    }, {
        "text": "钦州市",
        "value": 450700,
        "children": [{
            "text": "钦南区",
            "value": 450702
        }, {
            "text": "钦北区",
            "value": 450703
        }, {
            "text": "灵山县",
            "value": 450721
        }, {
            "text": "浦北县",
            "value": 450722
        }]
    }, {
        "text": "贵港市",
        "value": 450800,
        "children": [{
            "text": "港北区",
            "value": 450802
        }, {
            "text": "港南区",
            "value": 450803
        }, {
            "text": "覃塘区",
            "value": 450804
        }, {
            "text": "平南县",
            "value": 450821
        }, {
            "text": "桂平市",
            "value": 450881
        }]
    }, {
        "text": "玉林市",
        "value": 450900,
        "children": [{
            "text": "玉州区",
            "value": 450902
        }, {
            "text": "福绵区",
            "value": 450903
        }, {
            "text": "容县",
            "value": 450921
        }, {
            "text": "陆川县",
            "value": 450922
        }, {
            "text": "博白县",
            "value": 450923
        }, {
            "text": "兴业县",
            "value": 450924
        }, {
            "text": "北流市",
            "value": 450981
        }]
    }, {
        "text": "百色市",
        "value": 451000,
        "children": [{
            "text": "右江区",
            "value": 451002
        }, {
            "text": "田阳区",
            "value": 451003
        }, {
            "text": "田东县",
            "value": 451022
        }, {
            "text": "德保县",
            "value": 451024
        }, {
            "text": "那坡县",
            "value": 451026
        }, {
            "text": "凌云县",
            "value": 451027
        }, {
            "text": "乐业县",
            "value": 451028
        }, {
            "text": "田林县",
            "value": 451029
        }, {
            "text": "西林县",
            "value": 451030
        }, {
            "text": "隆林各族自治县",
            "value": 451031
        }, {
            "text": "靖西市",
            "value": 451081
        }, {
            "text": "平果市",
            "value": 451082
        }]
    }, {
        "text": "贺州市",
        "value": 451100,
        "children": [{
            "text": "八步区",
            "value": 451102
        }, {
            "text": "平桂区",
            "value": 451103
        }, {
            "text": "昭平县",
            "value": 451121
        }, {
            "text": "钟山县",
            "value": 451122
        }, {
            "text": "富川瑶族自治县",
            "value": 451123
        }]
    }, {
        "text": "河池市",
        "value": 451200,
        "children": [{
            "text": "金城江区",
            "value": 451202
        }, {
            "text": "宜州区",
            "value": 451203
        }, {
            "text": "南丹县",
            "value": 451221
        }, {
            "text": "天峨县",
            "value": 451222
        }, {
            "text": "凤山县",
            "value": 451223
        }, {
            "text": "东兰县",
            "value": 451224
        }, {
            "text": "罗城仫佬族自治县",
            "value": 451225
        }, {
            "text": "环江毛南族自治县",
            "value": 451226
        }, {
            "text": "巴马瑶族自治县",
            "value": 451227
        }, {
            "text": "都安瑶族自治县",
            "value": 451228
        }, {
            "text": "大化瑶族自治县",
            "value": 451229
        }]
    }, {
        "text": "来宾市",
        "value": 451300,
        "children": [{
            "text": "兴宾区",
            "value": 451302
        }, {
            "text": "忻城县",
            "value": 451321
        }, {
            "text": "象州县",
            "value": 451322
        }, {
            "text": "武宣县",
            "value": 451323
        }, {
            "text": "金秀瑶族自治县",
            "value": 451324
        }, {
            "text": "合山市",
            "value": 451381
        }]
    }, {
        "text": "崇左市",
        "value": 451400,
        "children": [{
            "text": "江州区",
            "value": 451402
        }, {
            "text": "扶绥县",
            "value": 451421
        }, {
            "text": "宁明县",
            "value": 451422
        }, {
            "text": "龙州县",
            "value": 451423
        }, {
            "text": "大新县",
            "value": 451424
        }, {
            "text": "天等县",
            "value": 451425
        }, {
            "text": "凭祥市",
            "value": 451481
        }]
    }]
}, {
    "text": "海南省",
    "value": 460000,
    "children": [{
        "text": "海口市",
        "value": 460100,
        "children": [{
            "text": "秀英区",
            "value": 460105
        }, {
            "text": "龙华区",
            "value": 460106
        }, {
            "text": "琼山区",
            "value": 460107
        }, {
            "text": "美兰区",
            "value": 460108
        }]
    }, {
        "text": "三亚市",
        "value": 460200,
        "children": [{
            "text": "海棠区",
            "value": 460202
        }, {
            "text": "吉阳区",
            "value": 460203
        }, {
            "text": "天涯区",
            "value": 460204
        }, {
            "text": "崖州区",
            "value": 460205
        }]
    }, {
        "text": "三沙市",
        "value": 460300,
        "children": [{
            "text": "西沙群岛",
            "value": 460321
        }, {
            "text": "南沙群岛",
            "value": 460322
        }, {
            "text": "中沙群岛的岛礁及其海域",
            "value": 460323
        }]
    }, {
        "text": "儋州市",
        "value": 460400,
        "children": [{
            "text": "儋州市",
            "value": 460400
        }]
    }, {
        "text": "五指山市",
        "value": 469001,
        "children": [{
            "text": "五指山市",
            "value": 469001
        }]
    }, {
        "text": "琼海市",
        "value": 469002,
        "children": [{
            "text": "琼海市",
            "value": 469002
        }]
    }, {
        "text": "文昌市",
        "value": 469005,
        "children": [{
            "text": "文昌市",
            "value": 469005
        }]
    }, {
        "text": "万宁市",
        "value": 469006,
        "children": [{
            "text": "万宁市",
            "value": 469006
        }]
    }, {
        "text": "东方市",
        "value": 469007,
        "children": [{
            "text": "东方市",
            "value": 469007
        }]
    }, {
        "text": "定安县",
        "value": 469021,
        "children": [{
            "text": "定安县",
            "value": 469021
        }]
    }, {
        "text": "屯昌县",
        "value": 469022,
        "children": [{
            "text": "屯昌县",
            "value": 469022
        }]
    }, {
        "text": "澄迈县",
        "value": 469023,
        "children": [{
            "text": "澄迈县",
            "value": 469023
        }]
    }, {
        "text": "临高县",
        "value": 469024,
        "children": [{
            "text": "临高县",
            "value": 469024
        }]
    }, {
        "text": "白沙黎族自治县",
        "value": 469025,
        "children": [{
            "text": "白沙黎族自治县",
            "value": 469025
        }]
    }, {
        "text": "昌江黎族自治县",
        "value": 469026,
        "children": [{
            "text": "昌江黎族自治县",
            "value": 469026
        }]
    }, {
        "text": "乐东黎族自治县",
        "value": 469027,
        "children": [{
            "text": "乐东黎族自治县",
            "value": 469027
        }]
    }, {
        "text": "陵水黎族自治县",
        "value": 469028,
        "children": [{
            "text": "陵水黎族自治县",
            "value": 469028
        }]
    }, {
        "text": "保亭黎族苗族自治县",
        "value": 469029,
        "children": [{
            "text": "保亭黎族苗族自治县",
            "value": 469029
        }]
    }, {
        "text": "琼中黎族苗族自治县",
        "value": 469030,
        "children": [{
            "text": "琼中黎族苗族自治县",
            "value": 469030
        }]
    }]
}, {
    "text": "重庆",
    "value": 500000,
    "children": [{
        "text": "重庆市",
        "value": 500100,
        "children": [{
            "text": "万州区",
            "value": 500101
        }, {
            "text": "涪陵区",
            "value": 500102
        }, {
            "text": "渝中区",
            "value": 500103
        }, {
            "text": "大渡口区",
            "value": 500104
        }, {
            "text": "江北区",
            "value": 500105
        }, {
            "text": "沙坪坝区",
            "value": 500106
        }, {
            "text": "九龙坡区",
            "value": 500107
        }, {
            "text": "南岸区",
            "value": 500108
        }, {
            "text": "北碚区",
            "value": 500109
        }, {
            "text": "綦江区",
            "value": 500110
        }, {
            "text": "大足区",
            "value": 500111
        }, {
            "text": "渝北区",
            "value": 500112
        }, {
            "text": "巴南区",
            "value": 500113
        }, {
            "text": "黔江区",
            "value": 500114
        }, {
            "text": "长寿区",
            "value": 500115
        }, {
            "text": "江津区",
            "value": 500116
        }, {
            "text": "合川区",
            "value": 500117
        }, {
            "text": "永川区",
            "value": 500118
        }, {
            "text": "南川区",
            "value": 500119
        }, {
            "text": "璧山区",
            "value": 500120
        }, {
            "text": "铜梁区",
            "value": 500151
        }, {
            "text": "潼南区",
            "value": 500152
        }, {
            "text": "荣昌区",
            "value": 500153
        }, {
            "text": "开州区",
            "value": 500154
        }, {
            "text": "梁平区",
            "value": 500155
        }, {
            "text": "武隆区",
            "value": 500156
        }]
    }, {
        "text": "重庆郊县",
        "value": 500200,
        "children": [{
            "text": "城口县",
            "value": 500229
        }, {
            "text": "丰都县",
            "value": 500230
        }, {
            "text": "垫江县",
            "value": 500231
        }, {
            "text": "忠县",
            "value": 500233
        }, {
            "text": "云阳县",
            "value": 500235
        }, {
            "text": "奉节县",
            "value": 500236
        }, {
            "text": "巫山县",
            "value": 500237
        }, {
            "text": "巫溪县",
            "value": 500238
        }, {
            "text": "石柱土家族自治县",
            "value": 500240
        }, {
            "text": "秀山土家族苗族自治县",
            "value": 500241
        }, {
            "text": "酉阳土家族苗族自治县",
            "value": 500242
        }, {
            "text": "彭水苗族土家族自治县",
            "value": 500243
        }]
    }]
}, {
    "text": "四川省",
    "value": 510000,
    "children": [{
        "text": "成都市",
        "value": 510100,
        "children": [{
            "text": "锦江区",
            "value": 510104
        }, {
            "text": "青羊区",
            "value": 510105
        }, {
            "text": "金牛区",
            "value": 510106
        }, {
            "text": "武侯区",
            "value": 510107
        }, {
            "text": "成华区",
            "value": 510108
        }, {
            "text": "龙泉驿区",
            "value": 510112
        }, {
            "text": "青白江区",
            "value": 510113
        }, {
            "text": "新都区",
            "value": 510114
        }, {
            "text": "温江区",
            "value": 510115
        }, {
            "text": "双流区",
            "value": 510116
        }, {
            "text": "郫都区",
            "value": 510117
        }, {
            "text": "金堂县",
            "value": 510121
        }, {
            "text": "大邑县",
            "value": 510129
        }, {
            "text": "蒲江县",
            "value": 510131
        }, {
            "text": "新津县",
            "value": 510132
        }, {
            "text": "都江堰市",
            "value": 510181
        }, {
            "text": "彭州市",
            "value": 510182
        }, {
            "text": "邛崃市",
            "value": 510183
        }, {
            "text": "崇州市",
            "value": 510184
        }, {
            "text": "简阳市",
            "value": 510185
        }]
    }, {
        "text": "自贡市",
        "value": 510300,
        "children": [{
            "text": "自流井区",
            "value": 510302
        }, {
            "text": "贡井区",
            "value": 510303
        }, {
            "text": "大安区",
            "value": 510304
        }, {
            "text": "沿滩区",
            "value": 510311
        }, {
            "text": "荣县",
            "value": 510321
        }, {
            "text": "富顺县",
            "value": 510322
        }]
    }, {
        "text": "攀枝花市",
        "value": 510400,
        "children": [{
            "text": "东区",
            "value": 510402
        }, {
            "text": "西区",
            "value": 510403
        }, {
            "text": "仁和区",
            "value": 510411
        }, {
            "text": "米易县",
            "value": 510421
        }, {
            "text": "盐边县",
            "value": 510422
        }]
    }, {
        "text": "泸州市",
        "value": 510500,
        "children": [{
            "text": "江阳区",
            "value": 510502
        }, {
            "text": "纳溪区",
            "value": 510503
        }, {
            "text": "龙马潭区",
            "value": 510504
        }, {
            "text": "泸县",
            "value": 510521
        }, {
            "text": "合江县",
            "value": 510522
        }, {
            "text": "叙永县",
            "value": 510524
        }, {
            "text": "古蔺县",
            "value": 510525
        }]
    }, {
        "text": "德阳市",
        "value": 510600,
        "children": [{
            "text": "旌阳区",
            "value": 510603
        }, {
            "text": "罗江区",
            "value": 510604
        }, {
            "text": "中江县",
            "value": 510623
        }, {
            "text": "广汉市",
            "value": 510681
        }, {
            "text": "什邡市",
            "value": 510682
        }, {
            "text": "绵竹市",
            "value": 510683
        }]
    }, {
        "text": "绵阳市",
        "value": 510700,
        "children": [{
            "text": "涪城区",
            "value": 510703
        }, {
            "text": "游仙区",
            "value": 510704
        }, {
            "text": "安州区",
            "value": 510705
        }, {
            "text": "三台县",
            "value": 510722
        }, {
            "text": "盐亭县",
            "value": 510723
        }, {
            "text": "梓潼县",
            "value": 510725
        }, {
            "text": "北川羌族自治县",
            "value": 510726
        }, {
            "text": "平武县",
            "value": 510727
        }, {
            "text": "江油市",
            "value": 510781
        }]
    }, {
        "text": "广元市",
        "value": 510800,
        "children": [{
            "text": "利州区",
            "value": 510802
        }, {
            "text": "昭化区",
            "value": 510811
        }, {
            "text": "朝天区",
            "value": 510812
        }, {
            "text": "旺苍县",
            "value": 510821
        }, {
            "text": "青川县",
            "value": 510822
        }, {
            "text": "剑阁县",
            "value": 510823
        }, {
            "text": "苍溪县",
            "value": 510824
        }]
    }, {
        "text": "遂宁市",
        "value": 510900,
        "children": [{
            "text": "船山区",
            "value": 510903
        }, {
            "text": "安居区",
            "value": 510904
        }, {
            "text": "蓬溪县",
            "value": 510921
        }, {
            "text": "大英县",
            "value": 510923
        }, {
            "text": "射洪市",
            "value": 510981
        }]
    }, {
        "text": "内江市",
        "value": 511000,
        "children": [{
            "text": "市中区",
            "value": 511002
        }, {
            "text": "东兴区",
            "value": 511011
        }, {
            "text": "威远县",
            "value": 511024
        }, {
            "text": "资中县",
            "value": 511025
        }, {
            "text": "隆昌市",
            "value": 511083
        }]
    }, {
        "text": "乐山市",
        "value": 511100,
        "children": [{
            "text": "市中区",
            "value": 511102
        }, {
            "text": "沙湾区",
            "value": 511111
        }, {
            "text": "五通桥区",
            "value": 511112
        }, {
            "text": "金口河区",
            "value": 511113
        }, {
            "text": "犍为县",
            "value": 511123
        }, {
            "text": "井研县",
            "value": 511124
        }, {
            "text": "夹江县",
            "value": 511126
        }, {
            "text": "沐川县",
            "value": 511129
        }, {
            "text": "峨边彝族自治县",
            "value": 511132
        }, {
            "text": "马边彝族自治县",
            "value": 511133
        }, {
            "text": "峨眉山市",
            "value": 511181
        }]
    }, {
        "text": "南充市",
        "value": 511300,
        "children": [{
            "text": "顺庆区",
            "value": 511302
        }, {
            "text": "高坪区",
            "value": 511303
        }, {
            "text": "嘉陵区",
            "value": 511304
        }, {
            "text": "南部县",
            "value": 511321
        }, {
            "text": "营山县",
            "value": 511322
        }, {
            "text": "蓬安县",
            "value": 511323
        }, {
            "text": "仪陇县",
            "value": 511324
        }, {
            "text": "西充县",
            "value": 511325
        }, {
            "text": "阆中市",
            "value": 511381
        }]
    }, {
        "text": "眉山市",
        "value": 511400,
        "children": [{
            "text": "东坡区",
            "value": 511402
        }, {
            "text": "彭山区",
            "value": 511403
        }, {
            "text": "仁寿县",
            "value": 511421
        }, {
            "text": "洪雅县",
            "value": 511423
        }, {
            "text": "丹棱县",
            "value": 511424
        }, {
            "text": "青神县",
            "value": 511425
        }]
    }, {
        "text": "宜宾市",
        "value": 511500,
        "children": [{
            "text": "翠屏区",
            "value": 511502
        }, {
            "text": "南溪区",
            "value": 511503
        }, {
            "text": "叙州区",
            "value": 511504
        }, {
            "text": "江安县",
            "value": 511523
        }, {
            "text": "长宁县",
            "value": 511524
        }, {
            "text": "高县",
            "value": 511525
        }, {
            "text": "珙县",
            "value": 511526
        }, {
            "text": "筠连县",
            "value": 511527
        }, {
            "text": "兴文县",
            "value": 511528
        }, {
            "text": "屏山县",
            "value": 511529
        }]
    }, {
        "text": "广安市",
        "value": 511600,
        "children": [{
            "text": "广安区",
            "value": 511602
        }, {
            "text": "前锋区",
            "value": 511603
        }, {
            "text": "岳池县",
            "value": 511621
        }, {
            "text": "武胜县",
            "value": 511622
        }, {
            "text": "邻水县",
            "value": 511623
        }, {
            "text": "华蓥市",
            "value": 511681
        }]
    }, {
        "text": "达州市",
        "value": 511700,
        "children": [{
            "text": "通川区",
            "value": 511702
        }, {
            "text": "达川区",
            "value": 511703
        }, {
            "text": "宣汉县",
            "value": 511722
        }, {
            "text": "开江县",
            "value": 511723
        }, {
            "text": "大竹县",
            "value": 511724
        }, {
            "text": "渠县",
            "value": 511725
        }, {
            "text": "万源市",
            "value": 511781
        }]
    }, {
        "text": "雅安市",
        "value": 511800,
        "children": [{
            "text": "雨城区",
            "value": 511802
        }, {
            "text": "名山区",
            "value": 511803
        }, {
            "text": "荥经县",
            "value": 511822
        }, {
            "text": "汉源县",
            "value": 511823
        }, {
            "text": "石棉县",
            "value": 511824
        }, {
            "text": "天全县",
            "value": 511825
        }, {
            "text": "芦山县",
            "value": 511826
        }, {
            "text": "宝兴县",
            "value": 511827
        }]
    }, {
        "text": "巴中市",
        "value": 511900,
        "children": [{
            "text": "巴州区",
            "value": 511902
        }, {
            "text": "恩阳区",
            "value": 511903
        }, {
            "text": "通江县",
            "value": 511921
        }, {
            "text": "南江县",
            "value": 511922
        }, {
            "text": "平昌县",
            "value": 511923
        }]
    }, {
        "text": "资阳市",
        "value": 512000,
        "children": [{
            "text": "雁江区",
            "value": 512002
        }, {
            "text": "安岳县",
            "value": 512021
        }, {
            "text": "乐至县",
            "value": 512022
        }]
    }, {
        "text": "阿坝藏族羌族自治州",
        "value": 513200,
        "children": [{
            "text": "马尔康市",
            "value": 513201
        }, {
            "text": "汶川县",
            "value": 513221
        }, {
            "text": "理县",
            "value": 513222
        }, {
            "text": "茂县",
            "value": 513223
        }, {
            "text": "松潘县",
            "value": 513224
        }, {
            "text": "九寨沟县",
            "value": 513225
        }, {
            "text": "金川县",
            "value": 513226
        }, {
            "text": "小金县",
            "value": 513227
        }, {
            "text": "黑水县",
            "value": 513228
        }, {
            "text": "壤塘县",
            "value": 513230
        }, {
            "text": "阿坝县",
            "value": 513231
        }, {
            "text": "若尔盖县",
            "value": 513232
        }, {
            "text": "红原县",
            "value": 513233
        }]
    }, {
        "text": "甘孜藏族自治州",
        "value": 513300,
        "children": [{
            "text": "康定市",
            "value": 513301
        }, {
            "text": "泸定县",
            "value": 513322
        }, {
            "text": "丹巴县",
            "value": 513323
        }, {
            "text": "九龙县",
            "value": 513324
        }, {
            "text": "雅江县",
            "value": 513325
        }, {
            "text": "道孚县",
            "value": 513326
        }, {
            "text": "炉霍县",
            "value": 513327
        }, {
            "text": "甘孜县",
            "value": 513328
        }, {
            "text": "新龙县",
            "value": 513329
        }, {
            "text": "德格县",
            "value": 513330
        }, {
            "text": "白玉县",
            "value": 513331
        }, {
            "text": "石渠县",
            "value": 513332
        }, {
            "text": "色达县",
            "value": 513333
        }, {
            "text": "理塘县",
            "value": 513334
        }, {
            "text": "巴塘县",
            "value": 513335
        }, {
            "text": "乡城县",
            "value": 513336
        }, {
            "text": "稻城县",
            "value": 513337
        }, {
            "text": "得荣县",
            "value": 513338
        }]
    }, {
        "text": "凉山彝族自治州",
        "value": 513400,
        "children": [{
            "text": "西昌市",
            "value": 513401
        }, {
            "text": "木里藏族自治县",
            "value": 513422
        }, {
            "text": "盐源县",
            "value": 513423
        }, {
            "text": "德昌县",
            "value": 513424
        }, {
            "text": "会理县",
            "value": 513425
        }, {
            "text": "会东县",
            "value": 513426
        }, {
            "text": "宁南县",
            "value": 513427
        }, {
            "text": "普格县",
            "value": 513428
        }, {
            "text": "布拖县",
            "value": 513429
        }, {
            "text": "金阳县",
            "value": 513430
        }, {
            "text": "昭觉县",
            "value": 513431
        }, {
            "text": "喜德县",
            "value": 513432
        }, {
            "text": "冕宁县",
            "value": 513433
        }, {
            "text": "越西县",
            "value": 513434
        }, {
            "text": "甘洛县",
            "value": 513435
        }, {
            "text": "美姑县",
            "value": 513436
        }, {
            "text": "雷波县",
            "value": 513437
        }]
    }]
}, {
    "text": "贵州省",
    "value": 520000,
    "children": [{
        "text": "贵阳市",
        "value": 520100,
        "children": [{
            "text": "南明区",
            "value": 520102
        }, {
            "text": "云岩区",
            "value": 520103
        }, {
            "text": "花溪区",
            "value": 520111
        }, {
            "text": "乌当区",
            "value": 520112
        }, {
            "text": "白云区",
            "value": 520113
        }, {
            "text": "观山湖区",
            "value": 520115
        }, {
            "text": "开阳县",
            "value": 520121
        }, {
            "text": "息烽县",
            "value": 520122
        }, {
            "text": "修文县",
            "value": 520123
        }, {
            "text": "清镇市",
            "value": 520181
        }]
    }, {
        "text": "六盘水市",
        "value": 520200,
        "children": [{
            "text": "钟山区",
            "value": 520201
        }, {
            "text": "六枝特区",
            "value": 520203
        }, {
            "text": "水城县",
            "value": 520221
        }, {
            "text": "盘州市",
            "value": 520281
        }]
    }, {
        "text": "遵义市",
        "value": 520300,
        "children": [{
            "text": "红花岗区",
            "value": 520302
        }, {
            "text": "汇川区",
            "value": 520303
        }, {
            "text": "播州区",
            "value": 520304
        }, {
            "text": "桐梓县",
            "value": 520322
        }, {
            "text": "绥阳县",
            "value": 520323
        }, {
            "text": "正安县",
            "value": 520324
        }, {
            "text": "道真仡佬族苗族自治县",
            "value": 520325
        }, {
            "text": "务川仡佬族苗族自治县",
            "value": 520326
        }, {
            "text": "凤冈县",
            "value": 520327
        }, {
            "text": "湄潭县",
            "value": 520328
        }, {
            "text": "余庆县",
            "value": 520329
        }, {
            "text": "习水县",
            "value": 520330
        }, {
            "text": "赤水市",
            "value": 520381
        }, {
            "text": "仁怀市",
            "value": 520382
        }]
    }, {
        "text": "安顺市",
        "value": 520400,
        "children": [{
            "text": "西秀区",
            "value": 520402
        }, {
            "text": "平坝区",
            "value": 520403
        }, {
            "text": "普定县",
            "value": 520422
        }, {
            "text": "镇宁布依族苗族自治县",
            "value": 520423
        }, {
            "text": "关岭布依族苗族自治县",
            "value": 520424
        }, {
            "text": "紫云苗族布依族自治县",
            "value": 520425
        }]
    }, {
        "text": "毕节市",
        "value": 520500,
        "children": [{
            "text": "七星关区",
            "value": 520502
        }, {
            "text": "大方县",
            "value": 520521
        }, {
            "text": "黔西县",
            "value": 520522
        }, {
            "text": "金沙县",
            "value": 520523
        }, {
            "text": "织金县",
            "value": 520524
        }, {
            "text": "纳雍县",
            "value": 520525
        }, {
            "text": "威宁彝族回族苗族自治县",
            "value": 520526
        }, {
            "text": "赫章县",
            "value": 520527
        }]
    }, {
        "text": "铜仁市",
        "value": 520600,
        "children": [{
            "text": "碧江区",
            "value": 520602
        }, {
            "text": "万山区",
            "value": 520603
        }, {
            "text": "江口县",
            "value": 520621
        }, {
            "text": "玉屏侗族自治县",
            "value": 520622
        }, {
            "text": "石阡县",
            "value": 520623
        }, {
            "text": "思南县",
            "value": 520624
        }, {
            "text": "印江土家族苗族自治县",
            "value": 520625
        }, {
            "text": "德江县",
            "value": 520626
        }, {
            "text": "沿河土家族自治县",
            "value": 520627
        }, {
            "text": "松桃苗族自治县",
            "value": 520628
        }]
    }, {
        "text": "黔西南布依族苗族自治州",
        "value": 522300,
        "children": [{
            "text": "兴义市",
            "value": 522301
        }, {
            "text": "兴仁市",
            "value": 522302
        }, {
            "text": "普安县",
            "value": 522323
        }, {
            "text": "晴隆县",
            "value": 522324
        }, {
            "text": "贞丰县",
            "value": 522325
        }, {
            "text": "望谟县",
            "value": 522326
        }, {
            "text": "册亨县",
            "value": 522327
        }, {
            "text": "安龙县",
            "value": 522328
        }]
    }, {
        "text": "黔东南苗族侗族自治州",
        "value": 522600,
        "children": [{
            "text": "凯里市",
            "value": 522601
        }, {
            "text": "黄平县",
            "value": 522622
        }, {
            "text": "施秉县",
            "value": 522623
        }, {
            "text": "三穗县",
            "value": 522624
        }, {
            "text": "镇远县",
            "value": 522625
        }, {
            "text": "岑巩县",
            "value": 522626
        }, {
            "text": "天柱县",
            "value": 522627
        }, {
            "text": "锦屏县",
            "value": 522628
        }, {
            "text": "剑河县",
            "value": 522629
        }, {
            "text": "台江县",
            "value": 522630
        }, {
            "text": "黎平县",
            "value": 522631
        }, {
            "text": "榕江县",
            "value": 522632
        }, {
            "text": "从江县",
            "value": 522633
        }, {
            "text": "雷山县",
            "value": 522634
        }, {
            "text": "麻江县",
            "value": 522635
        }, {
            "text": "丹寨县",
            "value": 522636
        }]
    }, {
        "text": "黔南布依族苗族自治州",
        "value": 522700,
        "children": [{
            "text": "都匀市",
            "value": 522701
        }, {
            "text": "福泉市",
            "value": 522702
        }, {
            "text": "荔波县",
            "value": 522722
        }, {
            "text": "贵定县",
            "value": 522723
        }, {
            "text": "瓮安县",
            "value": 522725
        }, {
            "text": "独山县",
            "value": 522726
        }, {
            "text": "平塘县",
            "value": 522727
        }, {
            "text": "罗甸县",
            "value": 522728
        }, {
            "text": "长顺县",
            "value": 522729
        }, {
            "text": "龙里县",
            "value": 522730
        }, {
            "text": "惠水县",
            "value": 522731
        }, {
            "text": "三都水族自治县",
            "value": 522732
        }]
    }]
}, {
    "text": "云南省",
    "value": 530000,
    "children": [{
        "text": "昆明市",
        "value": 530100,
        "children": [{
            "text": "五华区",
            "value": 530102
        }, {
            "text": "盘龙区",
            "value": 530103
        }, {
            "text": "官渡区",
            "value": 530111
        }, {
            "text": "西山区",
            "value": 530112
        }, {
            "text": "东川区",
            "value": 530113
        }, {
            "text": "呈贡区",
            "value": 530114
        }, {
            "text": "晋宁区",
            "value": 530115
        }, {
            "text": "富民县",
            "value": 530124
        }, {
            "text": "宜良县",
            "value": 530125
        }, {
            "text": "石林彝族自治县",
            "value": 530126
        }, {
            "text": "嵩明县",
            "value": 530127
        }, {
            "text": "禄劝彝族苗族自治县",
            "value": 530128
        }, {
            "text": "寻甸回族彝族自治县",
            "value": 530129
        }, {
            "text": "安宁市",
            "value": 530181
        }]
    }, {
        "text": "曲靖市",
        "value": 530300,
        "children": [{
            "text": "麒麟区",
            "value": 530302
        }, {
            "text": "沾益区",
            "value": 530303
        }, {
            "text": "马龙区",
            "value": 530304
        }, {
            "text": "陆良县",
            "value": 530322
        }, {
            "text": "师宗县",
            "value": 530323
        }, {
            "text": "罗平县",
            "value": 530324
        }, {
            "text": "富源县",
            "value": 530325
        }, {
            "text": "会泽县",
            "value": 530326
        }, {
            "text": "宣威市",
            "value": 530381
        }]
    }, {
        "text": "玉溪市",
        "value": 530400,
        "children": [{
            "text": "红塔区",
            "value": 530402
        }, {
            "text": "江川区",
            "value": 530403
        }, {
            "text": "通海县",
            "value": 530423
        }, {
            "text": "华宁县",
            "value": 530424
        }, {
            "text": "易门县",
            "value": 530425
        }, {
            "text": "峨山彝族自治县",
            "value": 530426
        }, {
            "text": "新平彝族傣族自治县",
            "value": 530427
        }, {
            "text": "元江哈尼族彝族傣族自治县",
            "value": 530428
        }, {
            "text": "澄江市",
            "value": 530481
        }]
    }, {
        "text": "保山市",
        "value": 530500,
        "children": [{
            "text": "隆阳区",
            "value": 530502
        }, {
            "text": "施甸县",
            "value": 530521
        }, {
            "text": "龙陵县",
            "value": 530523
        }, {
            "text": "昌宁县",
            "value": 530524
        }, {
            "text": "腾冲市",
            "value": 530581
        }]
    }, {
        "text": "昭通市",
        "value": 530600,
        "children": [{
            "text": "昭阳区",
            "value": 530602
        }, {
            "text": "鲁甸县",
            "value": 530621
        }, {
            "text": "巧家县",
            "value": 530622
        }, {
            "text": "盐津县",
            "value": 530623
        }, {
            "text": "大关县",
            "value": 530624
        }, {
            "text": "永善县",
            "value": 530625
        }, {
            "text": "绥江县",
            "value": 530626
        }, {
            "text": "镇雄县",
            "value": 530627
        }, {
            "text": "彝良县",
            "value": 530628
        }, {
            "text": "威信县",
            "value": 530629
        }, {
            "text": "水富市",
            "value": 530681
        }]
    }, {
        "text": "丽江市",
        "value": 530700,
        "children": [{
            "text": "古城区",
            "value": 530702
        }, {
            "text": "玉龙纳西族自治县",
            "value": 530721
        }, {
            "text": "永胜县",
            "value": 530722
        }, {
            "text": "华坪县",
            "value": 530723
        }, {
            "text": "宁蒗彝族自治县",
            "value": 530724
        }]
    }, {
        "text": "普洱市",
        "value": 530800,
        "children": [{
            "text": "思茅区",
            "value": 530802
        }, {
            "text": "宁洱哈尼族彝族自治县",
            "value": 530821
        }, {
            "text": "墨江哈尼族自治县",
            "value": 530822
        }, {
            "text": "景东彝族自治县",
            "value": 530823
        }, {
            "text": "景谷傣族彝族自治县",
            "value": 530824
        }, {
            "text": "镇沅彝族哈尼族拉祜族自治县",
            "value": 530825
        }, {
            "text": "江城哈尼族彝族自治县",
            "value": 530826
        }, {
            "text": "孟连傣族拉祜族佤族自治县",
            "value": 530827
        }, {
            "text": "澜沧拉祜族自治县",
            "value": 530828
        }, {
            "text": "西盟佤族自治县",
            "value": 530829
        }]
    }, {
        "text": "临沧市",
        "value": 530900,
        "children": [{
            "text": "临翔区",
            "value": 530902
        }, {
            "text": "凤庆县",
            "value": 530921
        }, {
            "text": "云县",
            "value": 530922
        }, {
            "text": "永德县",
            "value": 530923
        }, {
            "text": "镇康县",
            "value": 530924
        }, {
            "text": "双江拉祜族佤族布朗族傣族自治县",
            "value": 530925
        }, {
            "text": "耿马傣族佤族自治县",
            "value": 530926
        }, {
            "text": "沧源佤族自治县",
            "value": 530927
        }]
    }, {
        "text": "楚雄彝族自治州",
        "value": 532300,
        "children": [{
            "text": "楚雄市",
            "value": 532301
        }, {
            "text": "双柏县",
            "value": 532322
        }, {
            "text": "牟定县",
            "value": 532323
        }, {
            "text": "南华县",
            "value": 532324
        }, {
            "text": "姚安县",
            "value": 532325
        }, {
            "text": "大姚县",
            "value": 532326
        }, {
            "text": "永仁县",
            "value": 532327
        }, {
            "text": "元谋县",
            "value": 532328
        }, {
            "text": "武定县",
            "value": 532329
        }, {
            "text": "禄丰县",
            "value": 532331
        }]
    }, {
        "text": "红河哈尼族彝族自治州",
        "value": 532500,
        "children": [{
            "text": "个旧市",
            "value": 532501
        }, {
            "text": "开远市",
            "value": 532502
        }, {
            "text": "蒙自市",
            "value": 532503
        }, {
            "text": "弥勒市",
            "value": 532504
        }, {
            "text": "屏边苗族自治县",
            "value": 532523
        }, {
            "text": "建水县",
            "value": 532524
        }, {
            "text": "石屏县",
            "value": 532525
        }, {
            "text": "泸西县",
            "value": 532527
        }, {
            "text": "元阳县",
            "value": 532528
        }, {
            "text": "红河县",
            "value": 532529
        }, {
            "text": "金平苗族瑶族傣族自治县",
            "value": 532530
        }, {
            "text": "绿春县",
            "value": 532531
        }, {
            "text": "河口瑶族自治县",
            "value": 532532
        }]
    }, {
        "text": "文山壮族苗族自治州",
        "value": 532600,
        "children": [{
            "text": "文山市",
            "value": 532601
        }, {
            "text": "砚山县",
            "value": 532622
        }, {
            "text": "西畴县",
            "value": 532623
        }, {
            "text": "麻栗坡县",
            "value": 532624
        }, {
            "text": "马关县",
            "value": 532625
        }, {
            "text": "丘北县",
            "value": 532626
        }, {
            "text": "广南县",
            "value": 532627
        }, {
            "text": "富宁县",
            "value": 532628
        }]
    }, {
        "text": "西双版纳傣族自治州",
        "value": 532800,
        "children": [{
            "text": "景洪市",
            "value": 532801
        }, {
            "text": "勐海县",
            "value": 532822
        }, {
            "text": "勐腊县",
            "value": 532823
        }]
    }, {
        "text": "大理白族自治州",
        "value": 532900,
        "children": [{
            "text": "大理市",
            "value": 532901
        }, {
            "text": "漾濞彝族自治县",
            "value": 532922
        }, {
            "text": "祥云县",
            "value": 532923
        }, {
            "text": "宾川县",
            "value": 532924
        }, {
            "text": "弥渡县",
            "value": 532925
        }, {
            "text": "南涧彝族自治县",
            "value": 532926
        }, {
            "text": "巍山彝族回族自治县",
            "value": 532927
        }, {
            "text": "永平县",
            "value": 532928
        }, {
            "text": "云龙县",
            "value": 532929
        }, {
            "text": "洱源县",
            "value": 532930
        }, {
            "text": "剑川县",
            "value": 532931
        }, {
            "text": "鹤庆县",
            "value": 532932
        }]
    }, {
        "text": "德宏傣族景颇族自治州",
        "value": 533100,
        "children": [{
            "text": "瑞丽市",
            "value": 533102
        }, {
            "text": "芒市",
            "value": 533103
        }, {
            "text": "梁河县",
            "value": 533122
        }, {
            "text": "盈江县",
            "value": 533123
        }, {
            "text": "陇川县",
            "value": 533124
        }]
    }, {
        "text": "怒江傈僳族自治州",
        "value": 533300,
        "children": [{
            "text": "泸水市",
            "value": 533301
        }, {
            "text": "福贡县",
            "value": 533323
        }, {
            "text": "贡山独龙族怒族自治县",
            "value": 533324
        }, {
            "text": "兰坪白族普米族自治县",
            "value": 533325
        }]
    }, {
        "text": "迪庆藏族自治州",
        "value": 533400,
        "children": [{
            "text": "香格里拉市",
            "value": 533401
        }, {
            "text": "德钦县",
            "value": 533422
        }, {
            "text": "维西傈僳族自治县",
            "value": 533423
        }]
    }]
}, {
    "text": "西藏自治区",
    "value": 540000,
    "children": [{
        "text": "拉萨市",
        "value": 540100,
        "children": [{
            "text": "城关区",
            "value": 540102
        }, {
            "text": "堆龙德庆区",
            "value": 540103
        }, {
            "text": "达孜区",
            "value": 540104
        }, {
            "text": "林周县",
            "value": 540121
        }, {
            "text": "当雄县",
            "value": 540122
        }, {
            "text": "尼木县",
            "value": 540123
        }, {
            "text": "曲水县",
            "value": 540124
        }, {
            "text": "墨竹工卡县",
            "value": 540127
        }]
    }, {
        "text": "日喀则市",
        "value": 540200,
        "children": [{
            "text": "桑珠孜区",
            "value": 540202
        }, {
            "text": "南木林县",
            "value": 540221
        }, {
            "text": "江孜县",
            "value": 540222
        }, {
            "text": "定日县",
            "value": 540223
        }, {
            "text": "萨迦县",
            "value": 540224
        }, {
            "text": "拉孜县",
            "value": 540225
        }, {
            "text": "昂仁县",
            "value": 540226
        }, {
            "text": "谢通门县",
            "value": 540227
        }, {
            "text": "白朗县",
            "value": 540228
        }, {
            "text": "仁布县",
            "value": 540229
        }, {
            "text": "康马县",
            "value": 540230
        }, {
            "text": "定结县",
            "value": 540231
        }, {
            "text": "仲巴县",
            "value": 540232
        }, {
            "text": "亚东县",
            "value": 540233
        }, {
            "text": "吉隆县",
            "value": 540234
        }, {
            "text": "聂拉木县",
            "value": 540235
        }, {
            "text": "萨嘎县",
            "value": 540236
        }, {
            "text": "岗巴县",
            "value": 540237
        }]
    }, {
        "text": "昌都市",
        "value": 540300,
        "children": [{
            "text": "卡若区",
            "value": 540302
        }, {
            "text": "江达县",
            "value": 540321
        }, {
            "text": "贡觉县",
            "value": 540322
        }, {
            "text": "类乌齐县",
            "value": 540323
        }, {
            "text": "丁青县",
            "value": 540324
        }, {
            "text": "察雅县",
            "value": 540325
        }, {
            "text": "八宿县",
            "value": 540326
        }, {
            "text": "左贡县",
            "value": 540327
        }, {
            "text": "芒康县",
            "value": 540328
        }, {
            "text": "洛隆县",
            "value": 540329
        }, {
            "text": "边坝县",
            "value": 540330
        }]
    }, {
        "text": "林芝市",
        "value": 540400,
        "children": [{
            "text": "巴宜区",
            "value": 540402
        }, {
            "text": "工布江达县",
            "value": 540421
        }, {
            "text": "米林县",
            "value": 540422
        }, {
            "text": "墨脱县",
            "value": 540423
        }, {
            "text": "波密县",
            "value": 540424
        }, {
            "text": "察隅县",
            "value": 540425
        }, {
            "text": "朗县",
            "value": 540426
        }]
    }, {
        "text": "山南市",
        "value": 540500,
        "children": [{
            "text": "乃东区",
            "value": 540502
        }, {
            "text": "扎囊县",
            "value": 540521
        }, {
            "text": "贡嘎县",
            "value": 540522
        }, {
            "text": "桑日县",
            "value": 540523
        }, {
            "text": "琼结县",
            "value": 540524
        }, {
            "text": "曲松县",
            "value": 540525
        }, {
            "text": "措美县",
            "value": 540526
        }, {
            "text": "洛扎县",
            "value": 540527
        }, {
            "text": "加查县",
            "value": 540528
        }, {
            "text": "隆子县",
            "value": 540529
        }, {
            "text": "错那县",
            "value": 540530
        }, {
            "text": "浪卡子县",
            "value": 540531
        }]
    }, {
        "text": "那曲市",
        "value": 540600,
        "children": [{
            "text": "色尼区",
            "value": 540602
        }, {
            "text": "嘉黎县",
            "value": 540621
        }, {
            "text": "比如县",
            "value": 540622
        }, {
            "text": "聂荣县",
            "value": 540623
        }, {
            "text": "安多县",
            "value": 540624
        }, {
            "text": "申扎县",
            "value": 540625
        }, {
            "text": "索县",
            "value": 540626
        }, {
            "text": "班戈县",
            "value": 540627
        }, {
            "text": "巴青县",
            "value": 540628
        }, {
            "text": "尼玛县",
            "value": 540629
        }, {
            "text": "双湖县",
            "value": 540630
        }]
    }, {
        "text": "阿里地区",
        "value": 542500,
        "children": [{
            "text": "普兰县",
            "value": 542521
        }, {
            "text": "札达县",
            "value": 542522
        }, {
            "text": "噶尔县",
            "value": 542523
        }, {
            "text": "日土县",
            "value": 542524
        }, {
            "text": "革吉县",
            "value": 542525
        }, {
            "text": "改则县",
            "value": 542526
        }, {
            "text": "措勤县",
            "value": 542527
        }]
    }]
}, {
    "text": "陕西省",
    "value": 610000,
    "children": [{
        "text": "西安市",
        "value": 610100,
        "children": [{
            "text": "新城区",
            "value": 610102
        }, {
            "text": "碑林区",
            "value": 610103
        }, {
            "text": "莲湖区",
            "value": 610104
        }, {
            "text": "灞桥区",
            "value": 610111
        }, {
            "text": "未央区",
            "value": 610112
        }, {
            "text": "雁塔区",
            "value": 610113
        }, {
            "text": "阎良区",
            "value": 610114
        }, {
            "text": "临潼区",
            "value": 610115
        }, {
            "text": "长安区",
            "value": 610116
        }, {
            "text": "高陵区",
            "value": 610117
        }, {
            "text": "鄠邑区",
            "value": 610118
        }, {
            "text": "蓝田县",
            "value": 610122
        }, {
            "text": "周至县",
            "value": 610124
        }]
    }, {
        "text": "铜川市",
        "value": 610200,
        "children": [{
            "text": "王益区",
            "value": 610202
        }, {
            "text": "印台区",
            "value": 610203
        }, {
            "text": "耀州区",
            "value": 610204
        }, {
            "text": "宜君县",
            "value": 610222
        }]
    }, {
        "text": "宝鸡市",
        "value": 610300,
        "children": [{
            "text": "渭滨区",
            "value": 610302
        }, {
            "text": "金台区",
            "value": 610303
        }, {
            "text": "陈仓区",
            "value": 610304
        }, {
            "text": "凤翔县",
            "value": 610322
        }, {
            "text": "岐山县",
            "value": 610323
        }, {
            "text": "扶风县",
            "value": 610324
        }, {
            "text": "眉县",
            "value": 610326
        }, {
            "text": "陇县",
            "value": 610327
        }, {
            "text": "千阳县",
            "value": 610328
        }, {
            "text": "麟游县",
            "value": 610329
        }, {
            "text": "凤县",
            "value": 610330
        }, {
            "text": "太白县",
            "value": 610331
        }]
    }, {
        "text": "咸阳市",
        "value": 610400,
        "children": [{
            "text": "秦都区",
            "value": 610402
        }, {
            "text": "杨陵区",
            "value": 610403
        }, {
            "text": "渭城区",
            "value": 610404
        }, {
            "text": "三原县",
            "value": 610422
        }, {
            "text": "泾阳县",
            "value": 610423
        }, {
            "text": "乾县",
            "value": 610424
        }, {
            "text": "礼泉县",
            "value": 610425
        }, {
            "text": "永寿县",
            "value": 610426
        }, {
            "text": "长武县",
            "value": 610428
        }, {
            "text": "旬邑县",
            "value": 610429
        }, {
            "text": "淳化县",
            "value": 610430
        }, {
            "text": "武功县",
            "value": 610431
        }, {
            "text": "兴平市",
            "value": 610481
        }, {
            "text": "彬州市",
            "value": 610482
        }]
    }, {
        "text": "渭南市",
        "value": 610500,
        "children": [{
            "text": "临渭区",
            "value": 610502
        }, {
            "text": "华州区",
            "value": 610503
        }, {
            "text": "潼关县",
            "value": 610522
        }, {
            "text": "大荔县",
            "value": 610523
        }, {
            "text": "合阳县",
            "value": 610524
        }, {
            "text": "澄城县",
            "value": 610525
        }, {
            "text": "蒲城县",
            "value": 610526
        }, {
            "text": "白水县",
            "value": 610527
        }, {
            "text": "富平县",
            "value": 610528
        }, {
            "text": "韩城市",
            "value": 610581
        }, {
            "text": "华阴市",
            "value": 610582
        }]
    }, {
        "text": "延安市",
        "value": 610600,
        "children": [{
            "text": "宝塔区",
            "value": 610602
        }, {
            "text": "安塞区",
            "value": 610603
        }, {
            "text": "延长县",
            "value": 610621
        }, {
            "text": "延川县",
            "value": 610622
        }, {
            "text": "志丹县",
            "value": 610625
        }, {
            "text": "吴起县",
            "value": 610626
        }, {
            "text": "甘泉县",
            "value": 610627
        }, {
            "text": "富县",
            "value": 610628
        }, {
            "text": "洛川县",
            "value": 610629
        }, {
            "text": "宜川县",
            "value": 610630
        }, {
            "text": "黄龙县",
            "value": 610631
        }, {
            "text": "黄陵县",
            "value": 610632
        }, {
            "text": "子长市",
            "value": 610681
        }]
    }, {
        "text": "汉中市",
        "value": 610700,
        "children": [{
            "text": "汉台区",
            "value": 610702
        }, {
            "text": "南郑区",
            "value": 610703
        }, {
            "text": "城固县",
            "value": 610722
        }, {
            "text": "洋县",
            "value": 610723
        }, {
            "text": "西乡县",
            "value": 610724
        }, {
            "text": "勉县",
            "value": 610725
        }, {
            "text": "宁强县",
            "value": 610726
        }, {
            "text": "略阳县",
            "value": 610727
        }, {
            "text": "镇巴县",
            "value": 610728
        }, {
            "text": "留坝县",
            "value": 610729
        }, {
            "text": "佛坪县",
            "value": 610730
        }]
    }, {
        "text": "榆林市",
        "value": 610800,
        "children": [{
            "text": "榆阳区",
            "value": 610802
        }, {
            "text": "横山区",
            "value": 610803
        }, {
            "text": "府谷县",
            "value": 610822
        }, {
            "text": "靖边县",
            "value": 610824
        }, {
            "text": "定边县",
            "value": 610825
        }, {
            "text": "绥德县",
            "value": 610826
        }, {
            "text": "米脂县",
            "value": 610827
        }, {
            "text": "佳县",
            "value": 610828
        }, {
            "text": "吴堡县",
            "value": 610829
        }, {
            "text": "清涧县",
            "value": 610830
        }, {
            "text": "子洲县",
            "value": 610831
        }, {
            "text": "神木市",
            "value": 610881
        }]
    }, {
        "text": "安康市",
        "value": 610900,
        "children": [{
            "text": "汉滨区",
            "value": 610902
        }, {
            "text": "汉阴县",
            "value": 610921
        }, {
            "text": "石泉县",
            "value": 610922
        }, {
            "text": "宁陕县",
            "value": 610923
        }, {
            "text": "紫阳县",
            "value": 610924
        }, {
            "text": "岚皋县",
            "value": 610925
        }, {
            "text": "平利县",
            "value": 610926
        }, {
            "text": "镇坪县",
            "value": 610927
        }, {
            "text": "旬阳县",
            "value": 610928
        }, {
            "text": "白河县",
            "value": 610929
        }]
    }, {
        "text": "商洛市",
        "value": 611000,
        "children": [{
            "text": "商州区",
            "value": 611002
        }, {
            "text": "洛南县",
            "value": 611021
        }, {
            "text": "丹凤县",
            "value": 611022
        }, {
            "text": "商南县",
            "value": 611023
        }, {
            "text": "山阳县",
            "value": 611024
        }, {
            "text": "镇安县",
            "value": 611025
        }, {
            "text": "柞水县",
            "value": 611026
        }]
    }]
}, {
    "text": "甘肃省",
    "value": 620000,
    "children": [{
        "text": "兰州市",
        "value": 620100,
        "children": [{
            "text": "城关区",
            "value": 620102
        }, {
            "text": "七里河区",
            "value": 620103
        }, {
            "text": "西固区",
            "value": 620104
        }, {
            "text": "安宁区",
            "value": 620105
        }, {
            "text": "红古区",
            "value": 620111
        }, {
            "text": "永登县",
            "value": 620121
        }, {
            "text": "皋兰县",
            "value": 620122
        }, {
            "text": "榆中县",
            "value": 620123
        }]
    }, {
        "text": "嘉峪关市",
        "value": 620200,
        "children": [{
            "text": "嘉峪关市",
            "value": 620200
        }]
    }, {
        "text": "金昌市",
        "value": 620300,
        "children": [{
            "text": "金川区",
            "value": 620302
        }, {
            "text": "永昌县",
            "value": 620321
        }]
    }, {
        "text": "白银市",
        "value": 620400,
        "children": [{
            "text": "白银区",
            "value": 620402
        }, {
            "text": "平川区",
            "value": 620403
        }, {
            "text": "靖远县",
            "value": 620421
        }, {
            "text": "会宁县",
            "value": 620422
        }, {
            "text": "景泰县",
            "value": 620423
        }]
    }, {
        "text": "天水市",
        "value": 620500,
        "children": [{
            "text": "秦州区",
            "value": 620502
        }, {
            "text": "麦积区",
            "value": 620503
        }, {
            "text": "清水县",
            "value": 620521
        }, {
            "text": "秦安县",
            "value": 620522
        }, {
            "text": "甘谷县",
            "value": 620523
        }, {
            "text": "武山县",
            "value": 620524
        }, {
            "text": "张家川回族自治县",
            "value": 620525
        }]
    }, {
        "text": "武威市",
        "value": 620600,
        "children": [{
            "text": "凉州区",
            "value": 620602
        }, {
            "text": "民勤县",
            "value": 620621
        }, {
            "text": "古浪县",
            "value": 620622
        }, {
            "text": "天祝藏族自治县",
            "value": 620623
        }]
    }, {
        "text": "张掖市",
        "value": 620700,
        "children": [{
            "text": "甘州区",
            "value": 620702
        }, {
            "text": "肃南裕固族自治县",
            "value": 620721
        }, {
            "text": "民乐县",
            "value": 620722
        }, {
            "text": "临泽县",
            "value": 620723
        }, {
            "text": "高台县",
            "value": 620724
        }, {
            "text": "山丹县",
            "value": 620725
        }]
    }, {
        "text": "平凉市",
        "value": 620800,
        "children": [{
            "text": "崆峒区",
            "value": 620802
        }, {
            "text": "泾川县",
            "value": 620821
        }, {
            "text": "灵台县",
            "value": 620822
        }, {
            "text": "崇信县",
            "value": 620823
        }, {
            "text": "庄浪县",
            "value": 620825
        }, {
            "text": "静宁县",
            "value": 620826
        }, {
            "text": "华亭市",
            "value": 620881
        }]
    }, {
        "text": "酒泉市",
        "value": 620900,
        "children": [{
            "text": "肃州区",
            "value": 620902
        }, {
            "text": "金塔县",
            "value": 620921
        }, {
            "text": "瓜州县",
            "value": 620922
        }, {
            "text": "肃北蒙古族自治县",
            "value": 620923
        }, {
            "text": "阿克塞哈萨克族自治县",
            "value": 620924
        }, {
            "text": "玉门市",
            "value": 620981
        }, {
            "text": "敦煌市",
            "value": 620982
        }]
    }, {
        "text": "庆阳市",
        "value": 621000,
        "children": [{
            "text": "西峰区",
            "value": 621002
        }, {
            "text": "庆城县",
            "value": 621021
        }, {
            "text": "环县",
            "value": 621022
        }, {
            "text": "华池县",
            "value": 621023
        }, {
            "text": "合水县",
            "value": 621024
        }, {
            "text": "正宁县",
            "value": 621025
        }, {
            "text": "宁县",
            "value": 621026
        }, {
            "text": "镇原县",
            "value": 621027
        }]
    }, {
        "text": "定西市",
        "value": 621100,
        "children": [{
            "text": "安定区",
            "value": 621102
        }, {
            "text": "通渭县",
            "value": 621121
        }, {
            "text": "陇西县",
            "value": 621122
        }, {
            "text": "渭源县",
            "value": 621123
        }, {
            "text": "临洮县",
            "value": 621124
        }, {
            "text": "漳县",
            "value": 621125
        }, {
            "text": "岷县",
            "value": 621126
        }]
    }, {
        "text": "陇南市",
        "value": 621200,
        "children": [{
            "text": "武都区",
            "value": 621202
        }, {
            "text": "成县",
            "value": 621221
        }, {
            "text": "文县",
            "value": 621222
        }, {
            "text": "宕昌县",
            "value": 621223
        }, {
            "text": "康县",
            "value": 621224
        }, {
            "text": "西和县",
            "value": 621225
        }, {
            "text": "礼县",
            "value": 621226
        }, {
            "text": "徽县",
            "value": 621227
        }, {
            "text": "两当县",
            "value": 621228
        }]
    }, {
        "text": "临夏回族自治州",
        "value": 622900,
        "children": [{
            "text": "临夏市",
            "value": 622901
        }, {
            "text": "临夏县",
            "value": 622921
        }, {
            "text": "康乐县",
            "value": 622922
        }, {
            "text": "永靖县",
            "value": 622923
        }, {
            "text": "广河县",
            "value": 622924
        }, {
            "text": "和政县",
            "value": 622925
        }, {
            "text": "东乡族自治县",
            "value": 622926
        }, {
            "text": "积石山保安族东乡族撒拉族自治县",
            "value": 622927
        }]
    }, {
        "text": "甘南藏族自治州",
        "value": 623000,
        "children": [{
            "text": "合作市",
            "value": 623001
        }, {
            "text": "临潭县",
            "value": 623021
        }, {
            "text": "卓尼县",
            "value": 623022
        }, {
            "text": "舟曲县",
            "value": 623023
        }, {
            "text": "迭部县",
            "value": 623024
        }, {
            "text": "玛曲县",
            "value": 623025
        }, {
            "text": "碌曲县",
            "value": 623026
        }, {
            "text": "夏河县",
            "value": 623027
        }]
    }]
}, {
    "text": "青海省",
    "value": 630000,
    "children": [{
        "text": "西宁市",
        "value": 630100,
        "children": [{
            "text": "城东区",
            "value": 630102
        }, {
            "text": "城中区",
            "value": 630103
        }, {
            "text": "城西区",
            "value": 630104
        }, {
            "text": "城北区",
            "value": 630105
        }, {
            "text": "湟中区",
            "value": 630106
        }, {
            "text": "大通回族土族自治县",
            "value": 630121
        }, {
            "text": "湟源县",
            "value": 630123
        }]
    }, {
        "text": "海东市",
        "value": 630200,
        "children": [{
            "text": "乐都区",
            "value": 630202
        }, {
            "text": "平安区",
            "value": 630203
        }, {
            "text": "民和回族土族自治县",
            "value": 630222
        }, {
            "text": "互助土族自治县",
            "value": 630223
        }, {
            "text": "化隆回族自治县",
            "value": 630224
        }, {
            "text": "循化撒拉族自治县",
            "value": 630225
        }]
    }, {
        "text": "海北藏族自治州",
        "value": 632200,
        "children": [{
            "text": "门源回族自治县",
            "value": 632221
        }, {
            "text": "祁连县",
            "value": 632222
        }, {
            "text": "海晏县",
            "value": 632223
        }, {
            "text": "刚察县",
            "value": 632224
        }]
    }, {
        "text": "黄南藏族自治州",
        "value": 632300,
        "children": [{
            "text": "同仁县",
            "value": 632321
        }, {
            "text": "尖扎县",
            "value": 632322
        }, {
            "text": "泽库县",
            "value": 632323
        }, {
            "text": "河南蒙古族自治县",
            "value": 632324
        }]
    }, {
        "text": "海南藏族自治州",
        "value": 632500,
        "children": [{
            "text": "共和县",
            "value": 632521
        }, {
            "text": "同德县",
            "value": 632522
        }, {
            "text": "贵德县",
            "value": 632523
        }, {
            "text": "兴海县",
            "value": 632524
        }, {
            "text": "贵南县",
            "value": 632525
        }]
    }, {
        "text": "果洛藏族自治州",
        "value": 632600,
        "children": [{
            "text": "玛沁县",
            "value": 632621
        }, {
            "text": "班玛县",
            "value": 632622
        }, {
            "text": "甘德县",
            "value": 632623
        }, {
            "text": "达日县",
            "value": 632624
        }, {
            "text": "久治县",
            "value": 632625
        }, {
            "text": "玛多县",
            "value": 632626
        }]
    }, {
        "text": "玉树藏族自治州",
        "value": 632700,
        "children": [{
            "text": "玉树市",
            "value": 632701
        }, {
            "text": "杂多县",
            "value": 632722
        }, {
            "text": "称多县",
            "value": 632723
        }, {
            "text": "治多县",
            "value": 632724
        }, {
            "text": "囊谦县",
            "value": 632725
        }, {
            "text": "曲麻莱县",
            "value": 632726
        }]
    }, {
        "text": "海西蒙古族藏族自治州",
        "value": 632800,
        "children": [{
            "text": "格尔木市",
            "value": 632801
        }, {
            "text": "德令哈市",
            "value": 632802
        }, {
            "text": "茫崖市",
            "value": 632803
        }, {
            "text": "乌兰县",
            "value": 632821
        }, {
            "text": "都兰县",
            "value": 632822
        }, {
            "text": "天峻县",
            "value": 632823
        }, {
            "text": "海西蒙古族藏族自治州直辖",
            "value": 632825
        }]
    }]
}, {
    "text": "宁夏回族自治区",
    "value": 640000,
    "children": [{
        "text": "银川市",
        "value": 640100,
        "children": [{
            "text": "兴庆区",
            "value": 640104
        }, {
            "text": "西夏区",
            "value": 640105
        }, {
            "text": "金凤区",
            "value": 640106
        }, {
            "text": "永宁县",
            "value": 640121
        }, {
            "text": "贺兰县",
            "value": 640122
        }, {
            "text": "灵武市",
            "value": 640181
        }]
    }, {
        "text": "石嘴山市",
        "value": 640200,
        "children": [{
            "text": "大武口区",
            "value": 640202
        }, {
            "text": "惠农区",
            "value": 640205
        }, {
            "text": "平罗县",
            "value": 640221
        }]
    }, {
        "text": "吴忠市",
        "value": 640300,
        "children": [{
            "text": "利通区",
            "value": 640302
        }, {
            "text": "红寺堡区",
            "value": 640303
        }, {
            "text": "盐池县",
            "value": 640323
        }, {
            "text": "同心县",
            "value": 640324
        }, {
            "text": "青铜峡市",
            "value": 640381
        }]
    }, {
        "text": "固原市",
        "value": 640400,
        "children": [{
            "text": "原州区",
            "value": 640402
        }, {
            "text": "西吉县",
            "value": 640422
        }, {
            "text": "隆德县",
            "value": 640423
        }, {
            "text": "泾源县",
            "value": 640424
        }, {
            "text": "彭阳县",
            "value": 640425
        }]
    }, {
        "text": "中卫市",
        "value": 640500,
        "children": [{
            "text": "沙坡头区",
            "value": 640502
        }, {
            "text": "中宁县",
            "value": 640521
        }, {
            "text": "海原县",
            "value": 640522
        }]
    }]
}, {
    "text": "新疆维吾尔自治区",
    "value": 650000,
    "children": [{
        "text": "乌鲁木齐市",
        "value": 650100,
        "children": [{
            "text": "天山区",
            "value": 650102
        }, {
            "text": "沙依巴克区",
            "value": 650103
        }, {
            "text": "新市区",
            "value": 650104
        }, {
            "text": "水磨沟区",
            "value": 650105
        }, {
            "text": "头屯河区",
            "value": 650106
        }, {
            "text": "达坂城区",
            "value": 650107
        }, {
            "text": "米东区",
            "value": 650109
        }, {
            "text": "乌鲁木齐县",
            "value": 650121
        }]
    }, {
        "text": "克拉玛依市",
        "value": 650200,
        "children": [{
            "text": "独山子区",
            "value": 650202
        }, {
            "text": "克拉玛依区",
            "value": 650203
        }, {
            "text": "白碱滩区",
            "value": 650204
        }, {
            "text": "乌尔禾区",
            "value": 650205
        }]
    }, {
        "text": "吐鲁番市",
        "value": 650400,
        "children": [{
            "text": "高昌区",
            "value": 650402
        }, {
            "text": "鄯善县",
            "value": 650421
        }, {
            "text": "托克逊县",
            "value": 650422
        }]
    }, {
        "text": "哈密市",
        "value": 650500,
        "children": [{
            "text": "伊州区",
            "value": 650502
        }, {
            "text": "巴里坤哈萨克自治县",
            "value": 650521
        }, {
            "text": "伊吾县",
            "value": 650522
        }]
    }, {
        "text": "昌吉回族自治州",
        "value": 652300,
        "children": [{
            "text": "昌吉市",
            "value": 652301
        }, {
            "text": "阜康市",
            "value": 652302
        }, {
            "text": "呼图壁县",
            "value": 652323
        }, {
            "text": "玛纳斯县",
            "value": 652324
        }, {
            "text": "奇台县",
            "value": 652325
        }, {
            "text": "吉木萨尔县",
            "value": 652327
        }, {
            "text": "木垒哈萨克自治县",
            "value": 652328
        }]
    }, {
        "text": "博尔塔拉蒙古自治州",
        "value": 652700,
        "children": [{
            "text": "博乐市",
            "value": 652701
        }, {
            "text": "阿拉山口市",
            "value": 652702
        }, {
            "text": "精河县",
            "value": 652722
        }, {
            "text": "温泉县",
            "value": 652723
        }]
    }, {
        "text": "巴音郭楞蒙古自治州",
        "value": 652800,
        "children": [{
            "text": "库尔勒市",
            "value": 652801
        }, {
            "text": "轮台县",
            "value": 652822
        }, {
            "text": "尉犁县",
            "value": 652823
        }, {
            "text": "若羌县",
            "value": 652824
        }, {
            "text": "且末县",
            "value": 652825
        }, {
            "text": "焉耆回族自治县",
            "value": 652826
        }, {
            "text": "和静县",
            "value": 652827
        }, {
            "text": "和硕县",
            "value": 652828
        }, {
            "text": "博湖县",
            "value": 652829
        }]
    }, {
        "text": "阿克苏地区",
        "value": 652900,
        "children": [{
            "text": "阿克苏市",
            "value": 652901
        }, {
            "text": "库车市",
            "value": 652902
        }, {
            "text": "温宿县",
            "value": 652922
        }, {
            "text": "沙雅县",
            "value": 652924
        }, {
            "text": "新和县",
            "value": 652925
        }, {
            "text": "拜城县",
            "value": 652926
        }, {
            "text": "乌什县",
            "value": 652927
        }, {
            "text": "阿瓦提县",
            "value": 652928
        }, {
            "text": "柯坪县",
            "value": 652929
        }]
    }, {
        "text": "克孜勒苏柯尔克孜自治州",
        "value": 653000,
        "children": [{
            "text": "阿图什市",
            "value": 653001
        }, {
            "text": "阿克陶县",
            "value": 653022
        }, {
            "text": "阿合奇县",
            "value": 653023
        }, {
            "text": "乌恰县",
            "value": 653024
        }]
    }, {
        "text": "喀什地区",
        "value": 653100,
        "children": [{
            "text": "喀什市",
            "value": 653101
        }, {
            "text": "疏附县",
            "value": 653121
        }, {
            "text": "疏勒县",
            "value": 653122
        }, {
            "text": "英吉沙县",
            "value": 653123
        }, {
            "text": "泽普县",
            "value": 653124
        }, {
            "text": "莎车县",
            "value": 653125
        }, {
            "text": "叶城县",
            "value": 653126
        }, {
            "text": "麦盖提县",
            "value": 653127
        }, {
            "text": "岳普湖县",
            "value": 653128
        }, {
            "text": "伽师县",
            "value": 653129
        }, {
            "text": "巴楚县",
            "value": 653130
        }, {
            "text": "塔什库尔干塔吉克自治县",
            "value": 653131
        }]
    }, {
        "text": "和田地区",
        "value": 653200,
        "children": [{
            "text": "和田市",
            "value": 653201
        }, {
            "text": "和田县",
            "value": 653221
        }, {
            "text": "墨玉县",
            "value": 653222
        }, {
            "text": "皮山县",
            "value": 653223
        }, {
            "text": "洛浦县",
            "value": 653224
        }, {
            "text": "策勒县",
            "value": 653225
        }, {
            "text": "于田县",
            "value": 653226
        }, {
            "text": "民丰县",
            "value": 653227
        }]
    }, {
        "text": "伊犁哈萨克自治州",
        "value": 654000,
        "children": [{
            "text": "伊宁市",
            "value": 654002
        }, {
            "text": "奎屯市",
            "value": 654003
        }, {
            "text": "霍尔果斯市",
            "value": 654004
        }, {
            "text": "伊宁县",
            "value": 654021
        }, {
            "text": "察布查尔锡伯自治县",
            "value": 654022
        }, {
            "text": "霍城县",
            "value": 654023
        }, {
            "text": "巩留县",
            "value": 654024
        }, {
            "text": "新源县",
            "value": 654025
        }, {
            "text": "昭苏县",
            "value": 654026
        }, {
            "text": "特克斯县",
            "value": 654027
        }, {
            "text": "尼勒克县",
            "value": 654028
        }]
    }, {
        "text": "塔城地区",
        "value": 654200,
        "children": [{
            "text": "塔城市",
            "value": 654201
        }, {
            "text": "乌苏市",
            "value": 654202
        }, {
            "text": "额敏县",
            "value": 654221
        }, {
            "text": "沙湾县",
            "value": 654223
        }, {
            "text": "托里县",
            "value": 654224
        }, {
            "text": "裕民县",
            "value": 654225
        }, {
            "text": "和布克赛尔蒙古自治县",
            "value": 654226
        }]
    }, {
        "text": "阿勒泰地区",
        "value": 654300,
        "children": [{
            "text": "阿勒泰市",
            "value": 654301
        }, {
            "text": "布尔津县",
            "value": 654321
        }, {
            "text": "富蕴县",
            "value": 654322
        }, {
            "text": "福海县",
            "value": 654323
        }, {
            "text": "哈巴河县",
            "value": 654324
        }, {
            "text": "青河县",
            "value": 654325
        }, {
            "text": "吉木乃县",
            "value": 654326
        }]
    }, {
        "text": "石河子市",
        "value": 659001,
        "children": [{
            "text": "石河子市",
            "value": 659001
        }]
    }, {
        "text": "阿拉尔市",
        "value": 659002,
        "children": [{
            "text": "阿拉尔市",
            "value": 659002
        }]
    }, {
        "text": "图木舒克市",
        "value": 659003,
        "children": [{
            "text": "图木舒克市",
            "value": 659003
        }]
    }, {
        "text": "五家渠市",
        "value": 659004,
        "children": [{
            "text": "五家渠市",
            "value": 659004
        }]
    }, {
        "text": "北屯市",
        "value": 659005,
        "children": [{
            "text": "北屯市",
            "value": 659005
        }]
    }, {
        "text": "铁门关市",
        "value": 659006,
        "children": [{
            "text": "铁门关市",
            "value": 659006
        }]
    }, {
        "text": "双河市",
        "value": 659007,
        "children": [{
            "text": "双河市",
            "value": 659007
        }]
    }, {
        "text": "可克达拉市",
        "value": 659008,
        "children": [{
            "text": "可克达拉市",
            "value": 659008
        }]
    }, {
        "text": "昆玉市",
        "value": 659009,
        "children": [{
            "text": "昆玉市",
            "value": 659009
        }]
    }, {
        "text": "胡杨河市",
        "value": 659010,
        "children": [{
            "text": "胡杨河市",
            "value": 659010
        }]
    }]
}, {
    "text": "台湾省",
    "value": 710000,
    "children": []
}, {
    "text": "香港特别行政区",
    "value": 810000,
    "children": [{
        "text": "香港特别行政区",
        "value": 810000,
        "children": [{
            "text": "中西區",
            "value": 810001
        }, {
            "text": "灣仔區",
            "value": 810002
        }, {
            "text": "東區",
            "value": 810003
        }, {
            "text": "南區",
            "value": 810004
        }, {
            "text": "油尖旺區",
            "value": 810005
        }, {
            "text": "深水埗區",
            "value": 810006
        }, {
            "text": "九龍城區",
            "value": 810007
        }, {
            "text": "黃大仙區",
            "value": 810008
        }, {
            "text": "觀塘區",
            "value": 810009
        }, {
            "text": "荃灣區",
            "value": 810010
        }, {
            "text": "屯門區",
            "value": 810011
        }, {
            "text": "元朗區",
            "value": 810012
        }, {
            "text": "北區",
            "value": 810013
        }, {
            "text": "大埔區",
            "value": 810014
        }, {
            "text": "西貢區",
            "value": 810015
        }, {
            "text": "沙田區",
            "value": 810016
        }, {
            "text": "葵青區",
            "value": 810017
        }, {
            "text": "離島區",
            "value": 810018
        }]
    }]
}, {
    "text": "澳门特别行政区",
    "value": 820000,
    "children": [{
        "text": "澳门特别行政区",
        "value": 820000,
        "children": [{
            "text": "花地瑪堂區",
            "value": 820001
        }, {
            "text": "花王堂區",
            "value": 820002
        }, {
            "text": "望德堂區",
            "value": 820003
        }, {
            "text": "大堂區",
            "value": 820004
        }, {
            "text": "風順堂區",
            "value": 820005
        }, {
            "text": "嘉模堂區",
            "value": 820006
        }, {
            "text": "路氹填海區",
            "value": 820007
        }, {
            "text": "聖方濟各堂區",
            "value": 820008
        }]
    }]
}]